(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    if (new URLSearchParams(window.location.search).get("mode") === "view") return;
    var root = document.querySelector("[data-cp-designer]");
    if (!root) return;

    var CP = window.CustomPoster;
    CP.loadGoogleFonts();

    /* posterle: fontlarHazir (7 Eylul 2026)
       Font inmeden tuvale cizilen yazi YEDEK fontun olculeriyle cikiyor; olculdu:
       "WILD" Anton ile 183, sans-serif ile 255 birim -- %39 sapma, bantlar tasiyor.
       `loadGoogleFonts` yalnizca stil etiketini ekler; CSS fontlari KULLANILINCA
       iner ve canvas'a cizmek bunu tetiklemez, bu yuzden acikca istiyoruz.
       Font gelmezse 5 sn sonra yine de ciziyoruz - ozellik kilitlenmesin. */
    var fontlarHazir = (function () {
      if (!document.fonts || !document.fonts.load) return Promise.resolve();
      var aileler = [];
      (CP.FONTS || []).forEach(function (f) {
        var m = /'([^']+)'/.exec(f.css || "");
        if (m && aileler.indexOf(m[1]) === -1) aileler.push(m[1]);
      });
      if (!aileler.length) return Promise.resolve();

      /* Iki tuzak var, ikisi de olculerek bulundu:

         1) `document.fonts.load` Google Fonts STIL DOSYASI henuz inmemisken
            cagrilirsa eslesecek @font-face tanimi bulamaz ve BEKLEMEDEN coz olur.

         2) `document.fonts.check` TANIMLI OLMAYAN bir aile icin de `true` doner
            (yedek font kullanilacagi icin "yuklenecek bir sey yok" sayiyor).
            Yani hazir olup olmadigini ona SORAMAYIZ - ilk denemede tam bu yuzden
            kartlar yine yedek fontla cizildi.

         Bu yuzden hazirlik OLCULEREK anlasilıyor: ayni yazi, once olmayan bir
         aile adiyla (kesin yedege duser), sonra gercek aileyle olculuyor. Genislik
         farkliysa gercek font devrededir. */
      var olcuTuvali = document.createElement("canvas").getContext("2d");
      var SONDA = "WILDgood0123";
      var SONDA_TR = "ĞŞİğşı";     // latin-ext alt kumesi

      function olc(aile, metin) {
        olcuTuvali.font = '400 100px "' + aile + '", monospace';
        return olcuTuvali.measureText(metin).width;
      }
      var yedekLatin = olc("__posterle_olmayan_font__", SONDA);
      var yedekTr = olc("__posterle_olmayan_font__", SONDA_TR);

      /* TURKCE TUZAGI (7 Eylul 2026'da olculerek bulundu):
         Google Fonts her aileyi alt kumelere boluyor ve alt kume ancak O KARAKTERLER
         istendiginde iniyor. `document.fonts.load(...)` bos/latin sonda ile cagrilinca
         yalniz `latin` alt kumesi geliyor; Ğ Ş İ ğ ş gibi harfler YEDEK FONTLA
         ciziliyordu. Turkce bir magazada bu, musterinin yazdigi her Turkce harfi
         bozuyor. Bu yuzden hem YUKLEME hem KONTROL Turkce sondayla yapiliyor. */
      function geldi(aile) {
        return Math.abs(olc(aile, SONDA) - yedekLatin) > 0.5 &&
               Math.abs(olc(aile, SONDA_TR) - yedekTr) > 0.5;
      }

      function dene(kalanTur) {
        var isler = [];
        aileler.forEach(function (aile) {
          ["400", "700"].forEach(function (agirlik) {
            // Sonda metni ONEMLI: alt kume ancak istenen karakterler icin iniyor.
            // Turkce harfler verilmezse latin-ext hic gelmiyor (bkz. yukaridaki not).
            try {
              isler.push(document.fonts.load(agirlik + ' 100px "' + aile + '"',
                                             SONDA + SONDA_TR));
            } catch (e) { /* tarayici desteklemiyorsa gec */ }
          });
        });
        return Promise.all(isler).catch(function () {}).then(function () {
          var eksik = aileler.filter(function (aile) { return !geldi(aile); });
          if (!eksik.length || kalanTur <= 0) return;
          return new Promise(function (coz) { setTimeout(coz, 250); })
            .then(function () { return dene(kalanTur - 1); });
        });
      }

      // Font hic gelmezse ozellik kilitlenmesin: en fazla 6 sn bekle.
      // (Gec gelen font icin ayrica `window.__cpFontGec` var; bkz. asagisi.)
      var tumu = dene(40);
      window.__cpFontGec = Promise.race([
        tumu,
        new Promise(function (coz) { setTimeout(coz, 25000); })
      ]);
      return Promise.race([
        tumu,
        new Promise(function (coz) { setTimeout(coz, 6000); })
      ]);
    })();

    var backgrounds = JSON.parse(root.getAttribute("data-backgrounds") || "[]");
    var shapes = JSON.parse(root.getAttribute("data-shapes") || "[]");
    var productHandle = root.getAttribute("data-product-handle");
    var viewPageUrl = root.getAttribute("data-view-page-url");

    var canvas = root.querySelector("[data-cp-canvas]");
    var ctx = canvas.getContext("2d");
    canvas.width = CP.CANVAS_W;
    canvas.height = CP.CANVAS_H;

    var bgList = root.querySelector("[data-cp-bg-list]");
    var bgColorField = root.querySelector("[data-cp-bg-color-field]");
    var bgColorRoleList = root.querySelector("[data-cp-bg-color-roles]");
    var bgColorList = root.querySelector("[data-cp-bg-color-list]");
    var bgColorCustom = root.querySelector("[data-cp-bg-color-custom]");
    var shapeList = root.querySelector("[data-cp-shape-list]");
    var shapeToggleBtn = root.querySelector("[data-cp-toggle-shapes]");
    var shapePicker = root.querySelector("[data-cp-shape-picker]");
    var layerList = root.querySelector("[data-cp-layer-list]");
    var addLayerBtn = root.querySelector("[data-cp-add-layer]");
    var textField = root.querySelector("[data-cp-text-field]");
    var textInput = root.querySelector("[data-cp-text]");
    var symbolList = root.querySelector("[data-cp-symbol-list]");
    var fontField = root.querySelector("[data-cp-font-field]");
    var fontSelect = root.querySelector("[data-cp-font]");
    var styleField = root.querySelector("[data-cp-style-field]");
    var weightList = root.querySelector("[data-cp-weight-list]");
    var italicBtn = root.querySelector("[data-cp-italic]");
    var editingTitle = root.querySelector("[data-cp-editing-title]");
    var colorLabel = root.querySelector("[data-cp-color-label]");
    var colorDesc = root.querySelector("[data-cp-color-desc]");
    var colorRoleList = root.querySelector("[data-cp-color-roles]");
    var colorList = root.querySelector("[data-cp-color-list]");
    var colorCustom = root.querySelector("[data-cp-color-custom]");
    var paspartuToggle = root.querySelector("[data-cp-paspartu]");
    /* Cerceve rengi state'e KONMUYOR: state CP.encodeState ile baglantiya ve
       "Tasarimlarim" kayitlarina seri hale geliyor; yeni alan eski kayitlarin
       bicimini degistirirdi. Dogrudan DOM'dan okunuyor. */
    function seciliCerceveDegeri() {
      var s = root.querySelector('input[name="cp-cerceve"]:checked');
      return s ? s.value : "Siyah";
    }
    /* CERCEVE MODELI (Claude, 15 Eylul 2026): Basic (duvardan 1,5 cm) / Derin
       (3,5 cm). Bu urunde secenek eklemek olcu ayristirmasini bozdugu icin
       (bkz. poster-bot/kendi_tasarim_cerceve2.py) Derin ayri OLCU DEGERI olarak
       tutuluyor: "24x33 Derin". Listede yalniz Basic olculer var; model
       secimi sepete giden varyanti ve listedeki fiyatlari degistirir. */
    function seciliCerceveModeli() {
      var s = root.querySelector('input[name="cp-cerceve-modeli"]:checked');
      return s && (s.value === "Derin" || s.value === "Galeri") ? s.value : "Basic";
    }
    /* Olcunun secilen modeldeki esi: "24x33" -> "24x33 Derin" / "24x33 Galeri".
       GALERI (16 Eylul 2026) kucuk olculerde yok; esi olmayan olcude null doner. */
    function modelEsi(v, model) {
      if (!product || !v) return null;
      if (!model || model === "Basic") return v;
      return product.variants.find(function (vv) { return vv.title === v.title + " " + model; }) || null;
    }
    function derinEsi(v) { return modelEsi(v, "Derin"); }
    function modelSeceneginiGuncelle() {
      if (!product || !sizeSelect) return;
      var v = product.variants.find(function (vv) { return String(vv.id) === sizeSelect.value; });
      var galeri = root.querySelector('input[name="cp-cerceve-modeli"][value="Galeri"]');
      if (galeri) {
        var var_ = !!modelEsi(v, "Galeri");
        galeri.disabled = !var_;
        var etiket = galeri.closest("label");
        if (etiket) { etiket.style.opacity = var_ ? "" : "0.45"; etiket.title = var_ ? "" : "Bu ölçüde Galeri çerçeve yok"; }
        if (!var_ && galeri.checked) {
          var basic = root.querySelector('input[name="cp-cerceve-modeli"][value="Basic"]');
          if (basic) basic.checked = true;
        }
      }
      /* HANGI RENK HANGI MODELDE (23 Eylul 2026): Basic altisi da,
         Derin yalniz Siyah/Beyaz, Galeri yalniz Siyah. Katalogdaki urun
         sayfasiyla ayni kural. Uygun olmayan secenek kapatilir ve secili
         kalmissa Siyah'a donulur. */
      var model = seciliCerceveModeli();
      var izin = model === "Galeri" ? ["Siyah"]
               : model === "Derin" ? ["Siyah", "Beyaz"]
               : ["Siyah", "Beyaz", "Ceviz", "Kırmızı", "Pembe", "Sarı"];
      var geriDon = false;
      Array.prototype.forEach.call(root.querySelectorAll('input[name="cp-cerceve"]'), function (r) {
        var uygun = izin.indexOf(r.value) !== -1;
        r.disabled = !uygun;
        var et = r.closest("label");
        if (et) et.title = uygun ? "" : (model + " çerçevede bu renk yok");
        if (!uygun && r.checked) { r.checked = false; geriDon = true; }
      });
      if (geriDon) {
        var siyah = root.querySelector('input[name="cp-cerceve"][value="Siyah"]');
        if (siyah) { siyah.checked = true; siyah.dispatchEvent(new Event("change", { bubbles: true })); }
      }
    }
    function boyutEtiketleriniYaz() {
      if (!product || !sizeSelect) return;
      modelSeceneginiGuncelle();
      var model = seciliCerceveModeli();
      var para = (window.Shopify && Shopify.currency ? Shopify.currency.active : "TL");
      Array.prototype.forEach.call(sizeSelect.options, function (opt) {
        var v = product.variants.find(function (vv) { return String(vv.id) === opt.value; });
        if (!v) return;
        var es = modelEsi(v, model);
        var gosterilen = es || v;
        opt.textContent = v.title + " - " + (gosterilen.price / 100).toFixed(2) + " " + para +
          (model !== "Basic" && !es ? " (" + model + " yok)" : "");
      });
    }
    var sizeSelect = root.querySelector("[data-cp-size]");
    root.addEventListener("change", function (e) {
      if (e.target && (e.target.name === "cp-cerceve-modeli" || e.target === sizeSelect)) boyutEtiketleriniYaz();
    });
    var previewRatio = root.querySelector("[data-cp-preview-ratio]");
    var rotateBtn = root.querySelector("[data-cp-rotate]");
    var presetList = root.querySelector("[data-cp-preset-list]");
    var addBtn = root.querySelector("[data-cp-add]");
    var statusEl = root.querySelector("[data-cp-status]");

    var PRESET_DEFINITIONS = [
      {
        name: "GOOD VIBES CLUB",
        bg: "Dalgalı Dama",
        inspirationOnly: true,
        bgColors: { background: "#A73341", pattern: "#EFB0A6" },
        layers: [
          { type: "shape", shape: "Derin Dalgalı (3 renk)", colors: { outer: "#F7BD68", middle: "#2E5043", fill: "#D7C0DA" }, x: 0.5086, y: 0.5029, scale: 2.852, scaleY: 0.937 },
          { type: "shape", shape: "Bilet (çift renk)", colors: { outer: "#E46C60", fill: "#F7BE67" }, x: 0.4885, y: 0.7645, scale: 2.746, scaleY: 0.306 },
          { type: "shape", shape: "Dalgalı Rozet (çift renk)", colors: { outer: "#604481", fill: "#D6BFDA" }, x: 0.186, y: 0.1685, scale: 0.704, scaleY: 1.138 },
          { type: "shape", shape: "Işıltı", colors: { fill: "#F7BD65" }, x: 0.186, y: 0.169, scale: 0.456, scaleY: 1.294 },
          { type: "shape", shape: "Dalgalı Rozet (çift renk)", colors: { outer: "#604481", fill: "#D6BFDA" }, x: 0.81, y: 0.8615, scale: 0.71, scaleY: 1.128 },
          { type: "shape", shape: "Klasik Kalp", colors: { fill: "#E36B5F" }, x: 0.8145, y: 0.8591, scale: 0.369, scaleY: 1.248 },
          { type: "text", text: "GOOD", font: "abril", weight: "bold", color: "#511C47", x: 0.5013, y: 0.3685, scale: 2.05 },
          { type: "text", text: "vibes", font: "yellowtail", weight: "thin", color: "#D95D56", x: 0.4967, y: 0.4929, scale: 3.921 },
          { type: "text", text: "CLUB", font: "poppins", weight: "bold", color: "#2F5143", x: 0.4968, y: 0.6542, scale: 2.38 },
          { type: "text", text: "OPEN TO GOOD ENERGY", font: "mono", weight: "thin", color: "#E46C60", x: 0.4832, y: 0.7698, scale: 0.44 },
          { type: "shape", shape: "Işıltı", colors: { fill: "#F8BC58" }, x: 0.7605, y: 0.0704, scale: 0.627 }
        ]
      },
      {
        name: "STAY A LITTLE WILD",
        bg: "Leopar",
        inspirationOnly: true,
        bgColors: { background: "#A875E6", "pattern-mid": "#8A5A44", "pattern-dark": "#31153A" },
        layers: [
          { type: "shape", shape: "Organik Leke (çift renk)", colors: { outer: "#31153A", fill: "#FCD787" }, x: 0.4779, y: 0.4865, scale: 2.454, scaleY: 1.687 },
          { type: "shape", shape: "Dalgalı Rozet (çift renk)", colors: { outer: "#31153A", fill: "#C9A6DF" }, x: 0.82, y: 0.215, scale: 0.648 },
          { type: "shape", shape: "Işıltı (çift renk)", colors: { outer: "#CA5957", fill: "#F3AF7C" }, x: 0.82, y: 0.215, scale: 0.438, scaleY: 1.286 },
          { type: "shape", shape: "Bilet (çift renk)", colors: { outer: "#31153A", fill: "#F4B07E" }, x: 0.509, y: 0.504, scale: 2.978, scaleY: 0.572, rotation: -2 },
          { type: "shape", shape: "Bilet (çift renk)", colors: { outer: "#31153A", fill: "#CA5957" }, x: 0.5188, y: 0.7129, scale: 3.116, scaleY: 0.643, rotation: 2 },
          { type: "shape", shape: "Klasik Kalp (çift renk)", colors: { outer: "#CA5957", fill: "#F4AF7D" }, x: 0.1725, y: 0.8361, scale: 0.625, scaleY: 1.095 },
          { type: "text", text: "STAY", font: "anton", weight: "thin", color: "#31153B", x: 0.498, y: 0.3243, scale: 2.722 },
          { type: "text", text: "a little", font: "yellowtail", weight: "thin", color: "#31153A", x: 0.5086, y: 0.4957, scale: 2.525 },
          { type: "text", text: "WILD", font: "luckiest", weight: "bold", color: "#FCD787", x: 0.5365, y: 0.739, scale: 3.575 }
        ]
      },
      {
        name: "MORE AMOR",
        bg: "Kiraz",
        inspirationOnly: true,
        bgColors: { background: "#FDF1D2", "color-1": "#2F5743", "color-2": "#9D2A43", "color-3": "#F0A8A6" },
        layers: [
          { type: "shape", shape: "Klasik Kalp (3 renk)", colors: { outer: "#9F2B44", middle: "#ED8473", fill: "#F8C3C5" }, x: 0.5025, y: 0.4834, scale: 2.634, scaleY: 1.036 },
          { type: "shape", shape: "Klasik Kalp", colors: { fill: "#FDF1D2" }, x: 0.5025, y: 0.4905, scale: 2.099, scaleY: 1.069 },
          { type: "shape", shape: "Dalgalı Rozet (çift renk)", colors: { outer: "#604481", fill: "#F8BD65" }, x: 0.23, y: 0.1865, scale: 0.833, scaleY: 0.794 },
          { type: "shape", shape: "Işıltı", colors: { fill: "#832037" }, x: 0.23, y: 0.1865, scale: 0.512, scaleY: 1.107 },
          { type: "shape", shape: "Klasik Kalp (3 renk)", colors: { outer: "#9F2B44", middle: "#ED8473", fill: "#F8C3C5" }, x: 0.835, y: 0.1592, scale: 0.566, scaleY: 1.2 },
          { type: "shape", shape: "Klasik Kalp (3 renk)", colors: { outer: "#9F2B44", middle: "#ED8473", fill: "#F8C3C5" }, x: 0.1875, y: 0.7512, scale: 0.58, scaleY: 1.204 },
          { type: "shape", shape: "Bilet (çift renk)", colors: { outer: "#9F2B44", fill: "#F7C2C3" }, x: 0.523, y: 0.7967, scale: 2.215, scaleY: 0.414 },
          { type: "text", text: "MORE", font: "abril", weight: "bold", color: "#832037", x: 0.5116, y: 0.4321, scale: 2.075 },
          { type: "text", text: "AMOR", font: "poppins", weight: "bold", color: "#335643", x: 0.5045, y: 0.5525, scale: 1.867 },
          { type: "text", text: "every single day", font: "yellowtail", weight: "thin", color: "#9F2B44", x: 0.5246, y: 0.7962, scale: 0.756 }
        ]
      },
      {
        name: "COOL PEOPLE LIVE HERE",
        bg: "Dikey Çizgiler",
        bgColors: { background: "#E8DDC9", pattern: "#1A1A1A" },
        layers: [
          { type: "shape", shape: "Derin Dalgalı (çift renk)", colors: { outer: "#C0392B", fill: "#E8DDC9" }, x: 0.507, y: 0.4781, scale: 2.673, scaleY: 0.939 },
          { type: "text", text: "PEOPLE\nLIVE\nHERE", font: "bowlby", weight: "thin", color: "#2A4993", x: 0.5023, y: 0.543, scale: 1.359 },
          { type: "shape", shape: "Işıltı", colors: { fill: "#F8BC58" }, x: 0.807, y: 0.1562, scale: 0.506 },
          { type: "text", text: "COOL", font: "bowlby", weight: "thin", italic: true, color: "#2A4993", x: 0.4884, y: 0.3354, scale: 1.512 },
          { type: "shape", shape: "Işıltı", colors: { fill: "#F8BC58" }, x: 0.207, y: 0.1646, scale: 0.427 },
          { type: "shape", shape: "Işıltı", colors: { fill: "#F8BC58" }, x: 0.7767, y: 0.7962, scale: 0.463 },
          { type: "shape", shape: "Işıltı", colors: { fill: "#F8BC58" }, x: 0.2093, y: 0.7995, scale: 0.53 }
        ]
      },
{
        name: "OFF BEAT",
        bg: "Düz Renk",
        inspirationOnly: true,
        bgColors: { background: "#EF7447" },
        layers: [
          { type: "text", text: "OFF", font: "anton", weight: "bold", color: "#202B46", x: 0.4794, y: 0.2313, scale: 4.269 },
          { type: "text", text: "BEAT", font: "anton", weight: "bold", color: "#FFF1CC", x: 0.5767, y: 0.4531, scale: 3.208 },
          { type: "text", text: "FOLLOW YOUR OWN RHYTHM", font: "mono", weight: "bold", color: "#202B46", x: 0.1047, y: 0.4424, scale: 0.565, rotation: 90 },
          { type: "shape", shape: "Kıvrık Ok", colors: { fill: "#FFF1CC" }, x: 0.4256, y: 0.706, scale: 1 },
          { type: "shape", shape: "İnce Halka", colors: { middle: "#202B46" }, x: 0.6977, y: 0.7835, scale: 1 },
          { type: "shape", shape: "Çift Dalga", colors: { outer: "#FFF1CC", middle: "#202B46", fill: "#EF7447" }, x: 0.4465, y: 0.9122, scale: 1, scaleY: 0.365 },
          { type: "shape", shape: "Yumuşak Üçgen", colors: { fill: "#202B46" }, x: 0.7023, y: 0.7802, scale: 0.525, rotation: 90 },
          { type: "shape", shape: "İçi Boş Kare", colors: { outer: "#FFF1CC", middle: "#FF6B2C" }, x: 0.8302, y: 0.1632, scale: 0.438 },
          { type: "text", text: "NO RULES", font: "mono", weight: "bold", color: "#202B46", x: 0.4465, y: 0.9153, scale: 0.472 },
          { type: "shape", shape: "El Çizimi Çizgi", colors: { middle: "#202B46" }, x: 0.5744, y: 0.5384, scale: 1 },
          { type: "text", text: "♪", font: "playfair", weight: "bold", color: "#1A1A1A", x: 0.8326, y: 0.1647, scale: 1 }
        ]
      },
      {
        name: "Doğum Günü Pastel",
        bg: "Doğum Günü Pastel",
        photoTemplate: true,
        layers: [
          { type: "text", text: "MİRA", font: "playfair", color: "#3B281B", x: 0.5, y: 0.105, scale: 1.2 },
          { type: "text", text: "1 YAŞINDA", font: "playfair", color: "#3B281B", x: 0.53, y: 0.820, scale: 0.78 },
          { type: "text", text: "28 AĞUSTOS 2026", font: "playfair", weight: "thin", color: "#3B281B", x: 0.51, y: 0.942, scale: 0.40 }
        ]
      },
      {
        name: "Doğum Günü Gökkuşağı",
        bg: "Doğum Günü Gökkuşağı",
        photoTemplate: true,
        layers: [
          { type: "text", text: "MİRA", font: "playfair", color: "#8A74B7", x: 0.5, y: 0.105, scale: 1.2 },
          { type: "text", text: "1 YAŞINDA", font: "playfair", color: "#8A74B7", x: 0.5, y: 0.815, scale: 0.76 },
          { type: "text", text: "28 AĞUSTOS 2026", font: "playfair", weight: "thin", color: "#8A74B7", x: 0.5, y: 0.936, scale: 0.40 }
        ]
      },
      {
        name: "Doğum Günü Orman",
        bg: "Doğum Günü Orman",
        photoTemplate: true,
        layers: [
          { type: "text", text: "MİRA", font: "playfair", color: "#263015", x: 0.5, y: 0.105, scale: 1.18 },
          { type: "text", text: "1 YAŞINDA", font: "playfair", color: "#263015", x: 0.5, y: 0.825, scale: 0.75 },
          { type: "text", text: "28 AĞUSTOS 2026", font: "playfair", weight: "thin", color: "#263015", x: 0.5, y: 0.944, scale: 0.40 }
        ]
      },
      {
        name: "Doğum Günü Uzay",
        bg: "Doğum Günü Uzay",
        photoTemplate: true,
        layers: [
          { type: "text", text: "MİRA", font: "playfair", color: "#FFF1D1", x: 0.5, y: 0.105, scale: 1.18 },
          { type: "text", text: "1 YAŞINDA", font: "playfair", color: "#FFF1D1", x: 0.5, y: 0.823, scale: 0.75 },
          { type: "text", text: "28 AĞUSTOS 2026", font: "playfair", weight: "thin", color: "#17334B", x: 0.5, y: 0.943, scale: 0.40 }
        ]
      },
      {
        name: "Doğum Günü Parti",
        bg: "Doğum Günü Parti",
        photoTemplate: true,
        layers: [
          { type: "text", text: "MİRA", font: "playfair", color: "#F15C42", x: 0.5, y: 0.105, scale: 1.18 },
          { type: "text", text: "1 YAŞINDA", font: "playfair", color: "#1169B5", x: 0.5, y: 0.815, scale: 0.75 },
          { type: "text", text: "28 AĞUSTOS 2026", font: "playfair", weight: "bold", color: "#F15C42", x: 0.5, y: 0.936, scale: 0.40 }
        ]
      }
    ];

    var state = CP.defaultState();
    var activeLayerId = state.layers[0].id;
    var activeColorRole = "color"; // metin icin sabit; sekil icin 'outer'|'middle'|'fill'
    var activeBgColorRole = "";
    var bgImage = null;
    var bgImageCache = {};
    var shapeImageCache = {};
    var activePhotoTemplate = null;
    var templatePhotoImage = null;
    var product = null;

    function applyPosterSize(sizeLabel) {
      var dimensions = CP.canvasDimensionsForSize(sizeLabel);
      canvas.width = dimensions.width;
      canvas.height = dimensions.height;
      canvas.style.aspectRatio = dimensions.width + " / " + dimensions.height;
      if (previewRatio) previewRatio.textContent = dimensions.label;
      render();
    }

    function activeLayer() {
      var layer = state.layers.filter(function (l) { return l.id === activeLayerId; })[0];
      return layer || state.layers[0];
    }

    function setStatus(msg, isError) {
      if (!statusEl) return;
      statusEl.textContent = msg || "";
      statusEl.style.color = isError ? "#c0392b" : "";
    }

    function ensureShapeImagesLoaded() {
      state.layers
        .filter(function (l) { return l.type === "shape" && l.shapeUrl; })
        .forEach(function (l) {
          var key = CP.shapeImageKey(l);
          if (shapeImageCache[key]) return;
          CP.loadTintedShapeImage(l).then(function (img) {
            shapeImageCache[key] = img;
            render();
          }).catch(function (err) {
            console.error("[cp] shape tint failed", key, err);
          });
        });
    }

    // Canvas'in IC cozunurlugu (1000x1500) ekranda gosterilen boyutundan cok daha buyuk.
    // Telefonda canvas ~320px genisliginde cizildiginde olcek ~3.1x oluyor; bu yuzden
    // canvas pikseliyle yazilmis sabit boyutlar (tutamac yaricapi vb.) ekranda kucuciik
    // kaliyordu (~18px dokunma hedefi; WCAG 2.2 asgarisi 24px, onerilen 44px).
    // Cozum: tum dokunma/cizim olculerini EKRAN pikseli cinsinden tanimlayip canvas
    // olcegiyle carpmak. Boylece hem masaustunde hem mobilde ayni fiziksel buyuklukte olur.
    function canvasScale() {
      var rect = canvas.getBoundingClientRect();
      return rect.width > 0 ? canvas.width / rect.width : 1;
    }
    function px(cssPx) {
      return cssPx * canvasScale();
    }

    // Ekran pikseli cinsinden hedef olculer
    var HANDLE_VISUAL_R = 15; // gorunen daire yaricapi  -> ~30px capinda
    var HANDLE_HIT_R = 24;    // dokunma isabet yaricapi -> ~48px capinda (44px onerisinin ustunde)
    var BOX_PAD = 8;          // katman kutusu kenar toleransi

    function rotatedBoxPoint(box, localX, localY) {
      var rad = ((Number(box.rotation) || 0) * Math.PI) / 180;
      var cos = Math.cos(rad);
      var sin = Math.sin(rad);
      return {
        x: box.cx + localX * cos - localY * sin,
        y: box.cy + localX * sin + localY * cos
      };
    }

    // Tutamaclar katman kutusunun kosesinde durur. Buyutme sinirsiz oldugu icin kutu
    // tuvalden tasabilir; tasan durumda tutamac ekran disinda kalirsa kullanici sekli
    // BIR DAHA KUCULTEMEZ (geri alma yolu yalniz katmani silmek olurdu). Bu yuzden
    // tutamaclarin konumu tuvalin icine sikistiriliyor: buyutme serbest ama her zaman
    // geri alinabilir. Sikistirma yalniz tutamacin CIZILDIGI/yakalandigi yeri etkiler;
    // olcek hesabi (onPointerMove) kutunun gercek merkezine gore yapildigi icin degismez.
    function clampToCanvas(point) {
      var kenar = px(28);
      return {
        x: Math.min(canvas.width - kenar, Math.max(kenar, point.x)),
        y: Math.min(canvas.height - kenar, Math.max(kenar, point.y))
      };
    }

    function selectionHandles(box) {
      var offset = px(12);
      return {
        resize: clampToCanvas(rotatedBoxPoint(box, box.w / 2 + offset, box.h / 2 + offset)),
        rotate: clampToCanvas(rotatedBoxPoint(box, box.w / 2 + offset, -box.h / 2 - offset)),
        // Kenar tutamaclari (6 Eylul 2026): sag orta = genislik, alt orta = yukseklik.
        en: clampToCanvas(rotatedBoxPoint(box, box.w / 2 + offset, 0)),
        boy: clampToCanvas(rotatedBoxPoint(box, 0, box.h / 2 + offset))
      };
    }

    /* Tuval noktasini kutunun KENDI eksenine cevirir (donmus sekiller icin). */
    function yerelNokta(box, p) {
      var rad = -((Number(box.rotation) || 0) * Math.PI) / 180;
      var dx = p.x - box.cx;
      var dy = p.y - box.cy;
      return {
        x: dx * Math.cos(rad) - dy * Math.sin(rad),
        y: dx * Math.sin(rad) + dy * Math.cos(rad)
      };
    }

    function katmanBul(id) {
      return state.layers.filter(function (l) { return l.id === id; })[0];
    }

    function sekilMi(id) {
      var l = katmanBul(id);
      return !!(l && l.type === "shape");
    }

    /* Kenar tutamaci: beyaz yuvarlak + icinde yon cizgisi. */
    function cizKenarTutamaci(nokta, r, s, yon) {
      ctx.save();
      ctx.beginPath();
      ctx.arc(nokta.x, nokta.y, r * 0.86, 0, Math.PI * 2);
      ctx.fillStyle = "#ffffff";
      ctx.fill();
      ctx.lineWidth = 2 * s;
      ctx.strokeStyle = "#1a1a1a";
      ctx.stroke();
      var g = r * 0.38;
      ctx.beginPath();
      ctx.lineCap = "round";
      if (yon === "dikey") {
        ctx.moveTo(nokta.x, nokta.y - g);
        ctx.lineTo(nokta.x, nokta.y + g);
      } else {
        ctx.moveTo(nokta.x - g, nokta.y);
        ctx.lineTo(nokta.x + g, nokta.y);
      }
      ctx.stroke();
      ctx.restore();
    }

    function positionRotateButton(box) {
      if (!rotateBtn) return;
      if (!box) {
        rotateBtn.hidden = true;
        if (oranBtn) oranBtn.hidden = true;
        return;
      }
      var point = selectionHandles(box).rotate;
      var canvasRect = canvas.getBoundingClientRect();
      var boxRect = canvas.parentElement.getBoundingClientRect();
      var left = canvasRect.left - boxRect.left + (point.x / canvas.width) * canvasRect.width;
      var top = canvasRect.top - boxRect.top + (point.y / canvas.height) * canvasRect.height;
      left = Math.max(24, Math.min(boxRect.width - 24, left));
      top = Math.max(22, Math.min(boxRect.height - 22, top));
      rotateBtn.style.left = left + "px";
      rotateBtn.style.top = top + "px";
      rotateBtn.hidden = false;

      if (oranBtn) {
        var l2 = katmanBul(box.id);
        var gerilmis = l2 && l2.type === "shape" &&
          Math.abs((Number(l2.scaleY) > 0 ? Number(l2.scaleY) : 1) - 1) > 0.01;
        if (gerilmis) {
          oranBtn.style.left = left + "px";
          oranBtn.style.top = Math.min(boxRect.height - 22, top + 44) + "px";
          oranBtn.hidden = false;
        } else {
          oranBtn.hidden = true;
        }
      }
    }

    function drawSelectionUI(box) {
      if (!box) return;
      var s = canvasScale();
      var handleR = HANDLE_VISUAL_R * s;
      var glyph = handleR * 0.42;
      var handles = selectionHandles(box);
      var rotationRad = ((Number(box.rotation) || 0) * Math.PI) / 180;

      ctx.save();
      ctx.translate(box.cx, box.cy);
      ctx.rotate(rotationRad);
      ctx.strokeStyle = "#1a1a1a";
      ctx.lineWidth = 1.5 * s;
      ctx.setLineDash([6 * s, 4 * s]);
      var pad = BOX_PAD * s;
      ctx.strokeRect(-box.w / 2 - pad, -box.h / 2 - pad, box.w + pad * 2, box.h + pad * 2);
      ctx.setLineDash([]);
      ctx.restore();

      // Sag-alt kosedeki BUYUTME TUTAMACI - artik ekran olceginde sabit buyuklukte.
      ctx.save();
      ctx.beginPath();
      ctx.arc(handles.resize.x, handles.resize.y, handleR, 0, Math.PI * 2);
      ctx.fillStyle = "#ffffff";
      ctx.fill();
      ctx.lineWidth = 2 * s;
      ctx.strokeStyle = "#1a1a1a";
      ctx.stroke();

      ctx.strokeStyle = "#1a1a1a";
      ctx.lineWidth = 2 * s;
      ctx.lineCap = "round";
      ctx.beginPath();
      ctx.moveTo(handles.resize.x - glyph, handles.resize.y + glyph);
      ctx.lineTo(handles.resize.x + glyph, handles.resize.y - glyph);
      ctx.moveTo(handles.resize.x + glyph, handles.resize.y - glyph);
      ctx.lineTo(handles.resize.x + glyph * 0.15, handles.resize.y - glyph);
      ctx.moveTo(handles.resize.x + glyph, handles.resize.y - glyph);
      ctx.lineTo(handles.resize.x + glyph, handles.resize.y - glyph * 0.15);
      ctx.moveTo(handles.resize.x - glyph, handles.resize.y + glyph);
      ctx.lineTo(handles.resize.x - glyph * 0.15, handles.resize.y + glyph);
      ctx.moveTo(handles.resize.x - glyph, handles.resize.y + glyph);
      ctx.lineTo(handles.resize.x - glyph, handles.resize.y + glyph * 0.15);
      ctx.stroke();
      ctx.restore();

      // Kenar tutamaclari YALNIZ sekillerde. Yazida yok: yazinin en/boyu
      // yazi tipinden ve satirlardan geliyor, ayri gerilemez.
      if (sekilMi(box.id)) {
        cizKenarTutamaci(handles.en, handleR, s, "dikey");
        cizKenarTutamaci(handles.boy, handleR, s, "yatay");
      }
    }

    function coverImage(context, image, x, y, w, h) {
      var iw = image.naturalWidth || image.width || 1;
      var ih = image.naturalHeight || image.height || 1;
      var scale = Math.max(w / iw, h / ih);
      var sw = w / scale;
      var sh = h / scale;
      context.drawImage(image, (iw - sw) / 2, (ih - sh) / 2, sw, sh, x, y, w, h);
    }

    function archPath(context, x, y, w, h) {
      var radius = w / 2;
      context.beginPath();
      context.moveTo(x, y + radius);
      context.arc(x + radius, y + radius, radius, Math.PI, 0, false);
      context.lineTo(x + w, y + h);
      context.lineTo(x, y + h);
      context.closePath();
    }

    // Fotograflı dogum gunu sablonlarinda PNG sabit dekor tabanidir; musteri fotografi
    // tabandaki kemer boslugunun ustune, ayni kemer maskesiyle otomatik kirpilir.
    // Bu kompozit arka plan daha sonra mevcut CP.drawComposition'a verilir; yazilar yine
    // normal, secilebilir ve duzenlenebilir katmanlar olarak en ustte kalir.
    function photoTemplateBackground(W, H, template, baseImage, photo, showPrompt) {
      if (!template || !template.photoSlot || !baseImage) return baseImage;
      var out = document.createElement("canvas");
      out.width = W;
      out.height = H;
      var outCtx = out.getContext("2d");

      var iw = baseImage.naturalWidth || baseImage.width || 1;
      var ih = baseImage.naturalHeight || baseImage.height || 1;
      var baseScale = Math.max(W / iw, H / ih);
      var drawnW = iw * baseScale;
      var drawnH = ih * baseScale;
      var dx = (W - drawnW) / 2;
      var dy = (H - drawnH) / 2;
      outCtx.drawImage(baseImage, dx, dy, drawnW, drawnH);

      var slot = template.photoSlot;
      var sx = dx + slot.x * iw * baseScale;
      var sy = dy + slot.y * ih * baseScale;
      var sw = slot.w * iw * baseScale;
      var sh = slot.h * ih * baseScale;

      outCtx.save();
      archPath(outCtx, sx, sy, sw, sh);
      outCtx.clip();
      if (photo) {
        coverImage(outCtx, photo, sx, sy, sw, sh);
      } else {
        var grd = outCtx.createLinearGradient(sx, sy, sx, sy + sh);
        grd.addColorStop(0, "#f5f2ee");
        grd.addColorStop(1, "#e7e1da");
        outCtx.fillStyle = grd;
        outCtx.fillRect(sx, sy, sw, sh);
        if (showPrompt) {
          outCtx.fillStyle = "rgba(55,48,42,.58)";
          outCtx.font = "600 " + Math.max(11, Math.round(sw * 0.055)) + "px Arial, sans-serif";
          outCtx.textAlign = "center";
          outCtx.textBaseline = "middle";
          outCtx.fillText("FOTOĞRAFINI EKLE", sx + sw / 2, sy + sh / 2);
        }
      }
      outCtx.restore();
      return out;
    }

    function render() {
      var compositionBg = photoTemplateBackground(
        canvas.width, canvas.height, activePhotoTemplate, bgImage, templatePhotoImage, true
      );
      var result = CP.drawComposition(ctx, canvas.width, canvas.height, state, compositionBg, shapeImageCache);
      root._cpLayerBoxes = result.layerBoxes;
      var activeBox = result.layerBoxes.filter(function (b) { return b.id === activeLayerId; })[0];
      drawSelectionUI(activeBox);
      positionRotateButton(activeBox);
    }

    function findBackground(label) {
      return backgrounds.filter(function (bg) { return bg.label === label; })[0] || backgrounds[0] || null;
    }

    function findShape(label) {
      return shapes.filter(function (shape) { return shape.label === label; })[0] || null;
    }

    function buildPresetState(definition) {
      var next = CP.defaultState();
      var bg = findBackground(definition.bg);
      if (bg) {
        next.bg = bg.url;
        next.bgLabel = bg.label;
        next.bgParts = bg.parts ? bg.parts.slice() : [];
        next.bgColors = Object.assign({}, bg.defaultColors || {}, definition.bgColors || {});
      }
      next.layers = definition.layers.map(function (layerDef) {
        if (layerDef.type === "shape") {
          var shape = findShape(layerDef.shape);
          return CP.defaultShapeLayer({
            shapeUrl: shape ? shape.url : "",
            shapeLabel: shape ? shape.label : layerDef.shape,
            parts: shape && shape.parts ? shape.parts.slice() : ["outer", "middle", "fill"],
            colors: Object.assign({}, layerDef.colors || {}),
            x: layerDef.x,
            y: layerDef.y,
            scale: layerDef.scale,
            scaleY: Number(layerDef.scaleY) > 0 ? Number(layerDef.scaleY) : 1,
            rotation: layerDef.rotation || 0
          });
        }
        return CP.defaultLayer({
          text: layerDef.text,
          font: layerDef.font,
          weight: layerDef.weight || "bold",
          italic: !!layerDef.italic,
          color: layerDef.color,
          x: layerDef.x,
          y: layerDef.y,
          scale: layerDef.scale,
          rotation: layerDef.rotation || 0
        });
      });
      return next;
    }

    function loadPresetMedia(presetState) {
      var bgPromise = presetState.bgParts && presetState.bgParts.length
        ? CP.loadTintedBackgroundImage({ url: presetState.bg, parts: presetState.bgParts }, presetState.bgColors)
        : CP.loadImage(presetState.bg);
      var presetShapeImages = {};
      var shapePromises = presetState.layers
        .filter(function (layer) { return layer.type === "shape" && layer.shapeUrl; })
        .map(function (layer) {
          return CP.loadTintedShapeImage(layer).then(function (img) {
            presetShapeImages[CP.shapeImageKey(layer)] = img;
          });
        });
      return Promise.all([bgPromise].concat(shapePromises)).then(function (results) {
        return { bgImage: results[0], shapeImages: presetShapeImages };
      });
    }

    function applyPreset(definition, card) {
      var selectedSize = state.size;
      yuklemeyiBirak();   // sablon kendi arka planini getirir, yuklenen gorsel dusar
      state = buildPresetState(definition);
      var presetBg = findBackground(definition.bg);
      activePhotoTemplate = definition.photoTemplate && presetBg && presetBg.photoSlot ? presetBg : null;
      templatePhotoImage = null;
      state.size = selectedSize;
      activeLayerId = state.layers[0].id;
      activeColorRole = state.layers[0].type === "shape" ? state.layers[0].parts[0] : "color";
      activeBgColorRole = state.bgParts[0] || "";
      bgImage = null;
      paspartuToggle.checked = false;
      root.querySelectorAll("[data-cp-bg-item]").forEach(function (item) {
        item.classList.toggle("is-selected", item.getAttribute("data-url") === state.bg);
      });
      if (presetList) {
        presetList.querySelectorAll(".cp-preset-card").forEach(function (item) {
          item.classList.toggle("is-selected", item === card);
          item.setAttribute("aria-pressed", item === card ? "true" : "false");
        });
      }
      renderBgColorRoles();
      ensureBackgroundImageLoaded();
      ensureShapeImagesLoaded();
      syncFormToActiveLayer();
      renderLayerList();
      render();
      if (activePhotoTemplate) {
        yazi.textContent = "Çocuğunun fotoğrafı";
        yukleKutu.title = "Çocuğunun fotoğrafını yükle";
        setStatus("Şablon hazır. Şimdi ilk kutudan çocuğunun fotoğrafını yükle.");
      } else {
        yazi.textContent = "Kendi görselin";
        yukleKutu.title = "Kendi görselini yükle";
      }
    }

    function renderPresetCards() {
      if (!presetList) return;
      presetList.innerHTML = "";
      PRESET_DEFINITIONS.forEach(function (definition) {
        var card = document.createElement("button");
        card.type = "button";
        card.className = "cp-preset-card";
        card.setAttribute("aria-label", definition.name + " örnek tasarımını uygula");
        card.setAttribute("aria-pressed", "false");
        // Fotografli (dogum gunu) sablonlar yalniz "Sablondan Basla" vitrininde gorunur;
        // tasarimci ekranindaki ilham seridinde CSS ile gizlenirler.
        if (definition.photoTemplate) card.setAttribute("data-cp-photo", "1");
        // Ilham presetleri (Codex, 6 Eylul 2026) yalniz tasarimci ekranindaki
        // serite girer; "Sablonlar" vitrininde CSS ile gizlenirler.
        if (definition.inspirationOnly) card.setAttribute("data-cp-ilham", "1");

        var thumbnail = document.createElement("canvas");
        thumbnail.width = 240;
        thumbnail.height = 360;
        thumbnail.setAttribute("aria-hidden", "true");
        card.appendChild(thumbnail);

        var label = document.createElement("span");
        label.textContent = definition.name;
        card.appendChild(label);

        card.addEventListener("click", function () {
          applyPreset(definition, card);
        });
        presetList.appendChild(card);

        var thumbnailState = buildPresetState(definition);
        // Kucuk resim BIR KEZ ciziliyor; fontlar gelmeden cizilirse bozuk kalir.
        Promise.all([loadPresetMedia(thumbnailState), fontlarHazir]).then(function (sonuclar) {
          var media = sonuclar[0];
          var thumbCtx = thumbnail.getContext("2d");
          var presetBg = findBackground(definition.bg);
          var thumbBg = definition.photoTemplate
            ? photoTemplateBackground(thumbnail.width, thumbnail.height, presetBg, media.bgImage, null, true)
            : media.bgImage;
          CP.drawComposition(thumbCtx, thumbnail.width, thumbnail.height, thumbnailState, thumbBg, media.shapeImages, { showPlaceholders: false });
          // Font 6 sn'lik ilk beklemeye yetismediyse (ilk ziyaret / yavas baglanti)
          // kart yedek fontla cizilmis olur; geldiginde bir kez daha ciz.
          if (window.__cpFontGec) {
            window.__cpFontGec.then(function () {
              CP.drawComposition(thumbCtx, thumbnail.width, thumbnail.height, thumbnailState, thumbBg, media.shapeImages, { showPlaceholders: false });
            });
          }
        }).catch(function (err) {
          console.error("[cp] preset thumbnail failed", definition.name, err);
        });
      });
    }

    /* Gerilen sekli kendi oranina dondurur. Elle tam 1.000'e getirmek
       neredeyse imkansiz oldugu icin gerekli; yalniz gerilmis SEKIL secilince
       gorunur (bkz. positionRotateButton). */
    var oranBtn = null;
    if (rotateBtn && rotateBtn.parentNode) {
      oranBtn = document.createElement("button");
      oranBtn.type = "button";
      oranBtn.className = "cp-rotate-btn cp-oran-btn";
      oranBtn.hidden = true;
      oranBtn.title = "Şekli kendi oranına döndür";
      oranBtn.setAttribute("aria-label", "Şeklin en-boy oranını sıfırla");
      oranBtn.innerHTML = '<span aria-hidden="true">\u29C9</span><small>oran</small>';
      rotateBtn.parentNode.appendChild(oranBtn);
      oranBtn.addEventListener("click", function () {
        var l = activeLayer();
        if (!l || l.type !== "shape") return;
        l.scaleY = 1;
        render();
      });
    }

    if (rotateBtn) {
      rotateBtn.addEventListener("click", function () {
        var layer = activeLayer();
        if (!layer) return;
        layer.rotation = ((Number(layer.rotation) || 0) + 90) % 360;
        render();
      });
    }

    window.addEventListener("resize", function () {
      var boxes = root._cpLayerBoxes || [];
      var activeBox = boxes.filter(function (b) { return b.id === activeLayerId; })[0];
      positionRotateButton(activeBox);
    });

    function layerChipLabel(layer, idx) {
      if (layer.type === "shape") return "◆ " + (layer.shapeLabel || "Şekil " + (idx + 1));
      return layer.text && layer.text.trim() ? layer.text.slice(0, 16) : "Metin " + (idx + 1);
    }

    function moveLayer(layerId, dir) {
      var idx = state.layers.findIndex(function (l) { return l.id === layerId; });
      var newIdx = idx + dir;
      if (idx < 0 || newIdx < 0 || newIdx >= state.layers.length) return;
      var tmp = state.layers[idx];
      state.layers[idx] = state.layers[newIdx];
      state.layers[newIdx] = tmp;
      renderLayerList();
      render();
    }

    function renderLayerList() {
      layerList.innerHTML = "";
      state.layers.forEach(function (layer, idx) {
        var chip = document.createElement("div");
        chip.className = "cp-layer-chip" + (layer.id === activeLayerId ? " is-active" : "");

        var order = document.createElement("div");
        order.className = "cp-layer-chip-order";

        var upBtn = document.createElement("button");
        upBtn.type = "button";
        upBtn.textContent = "▲";
        upBtn.title = "Öne getir (üstüne çıkar)";
        upBtn.disabled = idx === state.layers.length - 1;
        upBtn.addEventListener("click", function (evt) {
          evt.stopPropagation();
          moveLayer(layer.id, 1);
        });
        order.appendChild(upBtn);

        var downBtn = document.createElement("button");
        downBtn.type = "button";
        downBtn.textContent = "▼";
        downBtn.title = "Arkaya gönder (altına al)";
        downBtn.disabled = idx === 0;
        downBtn.addEventListener("click", function (evt) {
          evt.stopPropagation();
          moveLayer(layer.id, -1);
        });
        order.appendChild(downBtn);

        chip.appendChild(order);

        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "cp-layer-chip-select";
        btn.textContent = layerChipLabel(layer, idx);
        btn.addEventListener("click", function () {
          activeLayerId = layer.id;
          syncFormToActiveLayer();
          renderLayerList();
        });
        chip.appendChild(btn);

        if (state.layers.length > 1) {
          var del = document.createElement("button");
          del.type = "button";
          del.className = "cp-layer-chip-remove";
          del.textContent = "×";
          del.title = "Bu katmanı sil";
          del.addEventListener("click", function (evt) {
            evt.stopPropagation();
            state.layers = state.layers.filter(function (l) { return l.id !== layer.id; });
            if (activeLayerId === layer.id) activeLayerId = state.layers[0].id;
            syncFormToActiveLayer();
            renderLayerList();
            render();
          });
          chip.appendChild(del);
        }

        layerList.appendChild(chip);
      });
    }

    function currentColorValue() {
      var layer = activeLayer();
      if (layer.type === "shape") return layer.colors[activeColorRole] || "";
      return layer.color;
    }

    function setCurrentColorValue(c) {
      var layer = activeLayer();
      if (layer.type === "shape") {
        layer.colors[activeColorRole] = c;
        ensureShapeImagesLoaded();
      } else {
        layer.color = c;
      }
    }

    function renderColorRoles() {
      var layer = activeLayer();
      colorRoleList.innerHTML = "";
      if (layer.type !== "shape") {
        colorRoleList.style.display = "none";
        // Metin katmani secilikken kullaniciya "bu YAZININ rengi" oldugunu acikca soyle
        if (colorLabel) colorLabel.textContent = "Yazı rengi";
        if (colorDesc) colorDesc.textContent = "Yukarıda yazdığın yazının rengini belirler.";
        if (editingTitle) editingTitle.textContent = "Şu an düzenlediğin: yazı";
        return;
      }
      colorRoleList.style.display = "";
      if (colorLabel) colorLabel.textContent = "Şeklin renkleri";
      if (colorDesc) colorDesc.textContent = "Önce şeklin hangi kısmını boyayacağını seç, sonra rengine tıkla.";
      if (editingTitle) editingTitle.textContent = "Şu an düzenlediğin: şekil — " + (layer.shapeLabel || "şekil");
      if (layer.parts.indexOf(activeColorRole) === -1) activeColorRole = layer.parts[0];
      layer.parts.forEach(function (part) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "cp-role-btn" + (part === activeColorRole ? " is-selected" : "");
        btn.textContent = CP.SHAPE_ROLE_LABELS[part] || part;
        btn.addEventListener("click", function () {
          activeColorRole = part;
          renderColorRoles();
          syncColorGridSelection();
        });
        colorRoleList.appendChild(btn);
      });
    }

    function syncColorGridSelection() {
      var c = currentColorValue();
      colorCustom.value = c || "#000000";
      root.querySelectorAll("[data-color]").forEach(function (el) {
        el.classList.toggle("is-selected", el.getAttribute("data-color") === c);
      });
    }

    function syncFormToActiveLayer() {
      var layer = activeLayer();
      var isText = layer.type !== "shape";
      textField.style.display = isText ? "" : "none";
      fontField.style.display = isText ? "" : "none";
      styleField.style.display = isText ? "" : "none";

      if (isText) {
        activeColorRole = "color";
        textInput.value = layer.text;
        fontSelect.value = layer.font;
        italicBtn.classList.toggle("is-selected", !!layer.italic);
        root.querySelectorAll("[data-weight]").forEach(function (el) {
          el.classList.toggle("is-selected", el.getAttribute("data-weight") === layer.weight);
        });
      } else if (layer.parts.indexOf(activeColorRole) === -1) {
        activeColorRole = layer.parts[0];
      }
      renderColorRoles();
      syncColorGridSelection();
    }

    addLayerBtn.addEventListener("click", function () {
      var newLayer = CP.defaultLayer({
        text: "Yeni yazı",
        y: Math.min(0.85, activeLayer().y + 0.18)
      });
      state.layers.push(newLayer);
      activeLayerId = newLayer.id;
      syncFormToActiveLayer();
      renderLayerList();
      render();
      if (shapeToggleBtn && shapePicker) {
        shapePicker.hidden = true;
        shapeToggleBtn.setAttribute("aria-expanded", "false");
        shapeToggleBtn.classList.remove("is-open");
      }
      window.setTimeout(function () {
        textInput.scrollIntoView({ behavior: "smooth", block: "center" });
        textInput.focus({ preventScroll: true });
        textInput.select();
      }, 0);
    });

    if (shapeToggleBtn && shapePicker) {
      shapeToggleBtn.addEventListener("click", function () {
        var willOpen = shapePicker.hidden;
        shapePicker.hidden = !willOpen;
        shapeToggleBtn.setAttribute("aria-expanded", String(willOpen));
        shapeToggleBtn.classList.toggle("is-open", willOpen);
      });
    }

    function ensureBackgroundImageLoaded() {
      var bg = { url: state.bg, parts: state.bgParts };
      var key = CP.bgImageKey(bg, state.bgColors);
      if (bgImageCache[key]) {
        bgImage = bgImageCache[key];
        render();
        return;
      }
      var loader = state.bgParts && state.bgParts.length
        ? CP.loadTintedBackgroundImage(bg, state.bgColors)
        : CP.loadImage(state.bg);
      loader.then(function (img) {
        bgImageCache[key] = img;
        if (state.bg === bg.url) {
          bgImage = img;
          render();
        }
      }).catch(function (err) {
        console.error("[cp] background load failed", err);
      });
    }

    function renderBgColorRoles() {
      bgColorRoleList.innerHTML = "";
      if (!state.bgParts || !state.bgParts.length) {
        bgColorField.style.display = "none";
        return;
      }
      bgColorField.style.display = "";
      if (state.bgParts.indexOf(activeBgColorRole) === -1) activeBgColorRole = state.bgParts[0];
      state.bgParts.forEach(function (part) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "cp-role-btn" + (part === activeBgColorRole ? " is-selected" : "");
        btn.textContent = CP.bgRoleLabel(part);
        btn.addEventListener("click", function () {
          activeBgColorRole = part;
          renderBgColorRoles();
          syncBgColorGridSelection();
        });
        bgColorRoleList.appendChild(btn);
      });
      syncBgColorGridSelection();
    }

    function syncBgColorGridSelection() {
      var c = (state.bgColors || {})[activeBgColorRole] || "";
      bgColorCustom.value = c || "#000000";
      bgColorList.querySelectorAll("[data-color]").forEach(function (el) {
        el.classList.toggle("is-selected", el.getAttribute("data-color") === c);
      });
    }

    function setBackground(bg) {
      state.bg = bg.url;
      state.bgLabel = bg.label;
      state.bgParts = bg.parts ? bg.parts.slice() : [];
      state.bgColors = bg.parts ? Object.assign({}, bg.defaultColors) : {};
      root.querySelectorAll("[data-cp-bg-item]").forEach(function (el) {
        el.classList.toggle("is-selected", el.getAttribute("data-url") === bg.url);
      });
      renderBgColorRoles();
      ensureBackgroundImageLoaded();
    }

    // Arka plan galerisi
    backgrounds.forEach(function (bg, idx) {
      if (bg.templateOnly) return;
      var item = document.createElement("button");
      item.type = "button";
      item.className = "cp-bg-item";
      item.setAttribute("data-cp-bg-item", "");
      item.setAttribute("data-url", bg.url);
      item.style.backgroundImage = "url('" + bg.url + "')";
      item.title = bg.label;
      item.addEventListener("click", function () {
        yuklemeyiBirak();
        setBackground(bg);
      });
      bgList.appendChild(item);
      if (idx === 0) setBackground(bg);
    });

    // ---- KENDI GORSELINI YUKLE (2026-08-28) ----
    // Musteri arka plan olarak kendi fotografini kullanabilir.
    // Gorsel data URL olarak okunur; canvas'i taintlemez, boylece "Cercevede onizle"
    // ve PNG indirme calismaya devam eder.
    // ASIL DOSYA sepete AYRICA satir ozelligi olarak yuklenir (bkz. "Sepete ekle") —
    // baski dosyasi ondan uretilir. Tasarim BAGLANTISINA konmaz, cunku bir fotografin
    // data URL'i baglantiyi megabaytlara cikarir ve satir ozelligine sigmaz.
    var yuklenenDosya = null;
    var YUKLEME_SINIRI = 15 * 1024 * 1024;  // 15 MB
    var ONERILEN_KENAR = 1200;              // altinda baski kalitesi uyarisi verilir

    var yukleGirdi = document.createElement("input");
    yukleGirdi.type = "file";
    yukleGirdi.accept = "image/png,image/jpeg,image/webp";
    yukleGirdi.hidden = true;

    var yukleKutu = document.createElement("button");
    yukleKutu.type = "button";
    yukleKutu.className = "cp-bg-item cp-bg-upload";
    yukleKutu.title = "Kendi görselini yükle";
    var arti = document.createElement("span");
    arti.className = "cp-bg-upload-plus";
    arti.setAttribute("aria-hidden", "true");
    arti.textContent = "+";
    var yazi = document.createElement("span");
    yazi.className = "cp-bg-upload-text";
    yazi.textContent = "Kendi görselin";
    yukleKutu.appendChild(arti);
    yukleKutu.appendChild(yazi);
    yukleKutu.addEventListener("click", function () { yukleGirdi.click(); });

    /* SAYFA BASINDAKI BUYUK BUTON (23 Eylul 2026) ayni yukleme girdisini
       aciyor; boylece "fotografimi bastirayim" diyen musteri arka plan
       kutucuklarini hic aramiyor. Yukleme bitince tuvale kaydiriyoruz. */
    document.addEventListener("click", function (olay) {
      var b = olay.target.closest && olay.target.closest("[data-cp-foto-yukle]");
      if (!b) return;
      olay.preventDefault();
      yukleGirdi.click();
    });

    // Baska bir arka plan secilince yuklenen gorseli birak.
    // (Fonksiyon bildirimi — yukaridaki galeri isleyicisinden once cagrilabilir.)
    function yuklemeyiBirak() {
      yuklenenDosya = null;
      templatePhotoImage = null;
      activePhotoTemplate = null;
      if (!yukleKutu) return;
      yukleKutu.classList.remove("is-selected");
      yukleKutu.classList.remove("cp-bg-upload--dolu");
      yukleKutu.style.backgroundImage = "";
      if (yazi) yazi.textContent = "Kendi görselin";
      yukleKutu.title = "Kendi görselini yükle";
    }

    yukleGirdi.addEventListener("change", function () {
      var f = yukleGirdi.files && yukleGirdi.files[0];
      yukleGirdi.value = "";
      if (!f) return;
      if (f.size > YUKLEME_SINIRI) {
        setStatus("Görsel çok büyük (en fazla 15 MB). Daha küçük bir dosya seç.", true);
        return;
      }
      var okuyucu = new FileReader();
      okuyucu.onerror = function () {
        setStatus("Dosya okunamadı, tekrar dener misin?", true);
      };
      okuyucu.onload = function () {
        var dataUrl = String(okuyucu.result);
        var olcum = new Image();
        olcum.onerror = function () {
          setStatus("Bu dosya görsel olarak açılamadı. PNG, JPG veya WEBP dene.", true);
        };
        olcum.onload = function () {
          if (activePhotoTemplate) {
            templatePhotoImage = olcum;
            render();
          } else {
            setBackground({ url: dataUrl, label: "Kendi görselin (" + f.name + ")", parts: [] });
          }
          yuklenenDosya = f;
          yukleKutu.classList.add("is-selected");
          yukleKutu.classList.add("cp-bg-upload--dolu");
          yukleKutu.style.backgroundImage = "url('" + dataUrl + "')";
          var olcu = olcum.width + "×" + olcum.height;
          if (Math.min(olcum.width, olcum.height) < ONERILEN_KENAR) {
            setStatus("Görselin eklendi ama çözünürlüğü düşük (" + olcu +
              "). Büyük boyutlarda baskıda bulanık çıkabilir.", true);
          } else {
            setStatus(activePhotoTemplate
              ? "Fotoğrafın şablona yerleştirildi (" + olcu + ")."
              : "Görselin arka plan olarak eklendi (" + olcu + ").");
          }
        };
        olcum.src = dataUrl;
      };
      okuyucu.readAsDataURL(f);
    });

    // Yukleme kutusu galerinin BASINDA dursun (kullanicinin istegi, 2026-08-28):
    // en gorunur yer orasi, musteri hazir desenleri gezmeden de kendi fotografini gorsun.
    bgList.insertBefore(yukleKutu, bgList.firstChild);
    bgList.appendChild(yukleGirdi);

    // ---- ORTAK RENK PALETI ----
    // Kullanici "kendi rengini sec" ile bir renk sectiginde o renk hatirlanir ve HER IKI
    // palette de (yazi/sekil + arka plan) en basa eklenir; boylece ayni rengi tasarimin her
    // yerinde tekrar tekrar secmek zorunda kalmaz. Sayfa yenilenince liste sifirlanir.
    var ozelRenkler = [];
    var OZEL_RENK_SINIRI = 12;

    function renkAnahtari(c) {
      return String(c || "").trim().toLowerCase();
    }

    function ozelRenkEkle(c) {
      var h = renkAnahtari(c);
      if (!h) return;
      // Hazir palette zaten varsa listeyi sisirmeye gerek yok
      var hazirVar = CP.COLORS.some(function (x) { return renkAnahtari(x) === h; });
      if (hazirVar) return;
      ozelRenkler = ozelRenkler.filter(function (x) { return renkAnahtari(x) !== h; });
      ozelRenkler.unshift(h);
      if (ozelRenkler.length > OZEL_RENK_SINIRI) ozelRenkler.length = OZEL_RENK_SINIRI;
      paletleriYenile();
    }

    function paletDoldur(kapsayici, secildiginde) {
      if (!kapsayici) return;
      kapsayici.textContent = "";
      var tumu = ozelRenkler.concat(CP.COLORS);
      tumu.forEach(function (c, i) {
        var ozelMi = i < ozelRenkler.length;
        var sw = document.createElement("button");
        sw.type = "button";
        sw.className = "cp-color-swatch" + (ozelMi ? " cp-color-swatch--ozel" : "");
        sw.style.background = c;
        sw.setAttribute("data-color", c);
        sw.title = ozelMi ? c + " (senin seçtiğin renk)" : c;
        sw.addEventListener("click", function () { secildiginde(c); });
        kapsayici.appendChild(sw);
      });
    }

    function paletleriYenile() {
      paletDoldur(colorList, function (c) {
        setCurrentColorValue(c);
        syncColorGridSelection();
        render();
      });
      paletDoldur(bgColorList, function (c) {
        state.bgColors[activeBgColorRole] = c;
        syncBgColorGridSelection();
        ensureBackgroundImageLoaded();
      });
      syncColorGridSelection();
      syncBgColorGridSelection();
    }

    bgColorCustom.addEventListener("input", function () {
      state.bgColors[activeBgColorRole] = bgColorCustom.value;
      bgColorList.querySelectorAll("[data-color]").forEach(function (el) {
        el.classList.remove("is-selected");
      });
      ensureBackgroundImageLoaded();
    });
    // 'change' renk secici KAPANINCA bir kez tetiklenir. 'input' surukleme boyunca onlarca kez
    // tetiklendigi icin hatirlanan listeye ancak burada eklemek dogru - yoksa palet ara tonlarla dolar.
    bgColorCustom.addEventListener("change", function () {
      ozelRenkEkle(bgColorCustom.value);
    });

    // Sekil galerisi - tiklaninca YENI bir sekil katmani ekler
    shapes.forEach(function (shape) {
      var item = document.createElement("button");
      item.type = "button";
      item.className = "cp-shape-item";
      var img = document.createElement("img");
      img.src = shape.url;
      img.alt = shape.label;
      item.appendChild(img);
      item.title = shape.label;
      item.addEventListener("click", function () {
        // Sekil listesinde "defaultColors" varsa (bkz. liquid: ince cizgi ailesi siyah baslar)
        // genel varsayilanin uzerine yazilir - arka planlardaki bg.defaultColors ile ayni mantik.
        var newLayer = CP.defaultShapeLayer({
          shapeUrl: shape.url,
          shapeLabel: shape.label,
          parts: shape.parts,
          colors: Object.assign({}, CP.DEFAULT_SHAPE_COLORS, shape.defaultColors || {}),
          y: Math.min(0.85, activeLayer().y)
        });
        state.layers.push(newLayer);
        activeLayerId = newLayer.id;
        ensureShapeImagesLoaded();
        syncFormToActiveLayer();
        renderLayerList();
        render();
        if (shapeToggleBtn && shapePicker) {
          shapePicker.hidden = true;
          shapeToggleBtn.setAttribute("aria-expanded", "false");
          shapeToggleBtn.classList.remove("is-open");
        }
      });
      shapeList.appendChild(item);
    });

    // Font secimi
    CP.FONTS.forEach(function (f) {
      var opt = document.createElement("option");
      opt.value = f.id;
      opt.textContent = f.label;
      opt.style.fontFamily = f.css;
      fontSelect.appendChild(opt);
    });
    fontSelect.addEventListener("change", function () {
      activeLayer().font = fontSelect.value;
      render();
    });

    // Kalinlik (ince/kalin)
    CP.WEIGHTS.forEach(function (w) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cp-weight-btn";
      btn.textContent = w.label;
      btn.setAttribute("data-weight", w.id);
      btn.style.fontWeight = w.css;
      btn.addEventListener("click", function () {
        activeLayer().weight = w.id;
        root.querySelectorAll("[data-weight]").forEach(function (el) {
          el.classList.toggle("is-selected", el.getAttribute("data-weight") === w.id);
        });
        render();
      });
      weightList.appendChild(btn);
    });

    // Italik
    italicBtn.addEventListener("click", function () {
      var layer = activeLayer();
      layer.italic = !layer.italic;
      italicBtn.classList.toggle("is-selected", !!layer.italic);
      render();
    });

    // Renk secimi - iki palet de paletleriYenile() tarafindan doldurulur (ozel renkler en basta)
    paletleriYenile();

    colorCustom.addEventListener("input", function () {
      setCurrentColorValue(colorCustom.value);
      root.querySelectorAll("[data-color]").forEach(function (el) {
        el.classList.remove("is-selected");
      });
      render();
    });
    colorCustom.addEventListener("change", function () {
      ozelRenkEkle(colorCustom.value);
    });

    // Yazi
    textInput.addEventListener("input", function () {
      activeLayer().text = textInput.value;
      renderLayerList();
      render();
    });

    // Klavyede olmayan semboller (kalp, yildiz vb.) - imlecin oldugu yere eklenir
    CP.SYMBOLS.forEach(function (sym) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cp-symbol-btn";
      btn.textContent = sym;
      btn.title = "Ekle: " + sym;
      // mousedown'da preventDefault, textarea'nin odagini/imlec konumunu kaybetmesini engeller
      btn.addEventListener("mousedown", function (evt) {
        evt.preventDefault();
      });
      btn.addEventListener("click", function () {
        // Simge paleti artik "Yeni sekil ekle" panelinde (kullanicinin istegi, 2026-08-28).
        // Orada tiklandiginda secili katman bir SEKIL olabilir ya da hic yazi katmani
        // olmayabilir; o durumda simgeyi imlece degil, YENI bir yazi katmani olarak ekle.
        var katman = activeLayer();
        if (!katman || katman.type === "shape") {
          var yeni = CP.defaultLayer({
            text: sym,
            y: Math.min(0.85, (katman ? katman.y : 0.5) + 0.18)
          });
          state.layers.push(yeni);
          activeLayerId = yeni.id;
          syncFormToActiveLayer();
          renderLayerList();
          render();
          return;
        }
        var start = textInput.selectionStart != null ? textInput.selectionStart : textInput.value.length;
        var end = textInput.selectionEnd != null ? textInput.selectionEnd : textInput.value.length;
        var val = textInput.value;
        var next = val.slice(0, start) + sym + val.slice(end);
        textInput.value = next;
        var newPos = start + sym.length;
        textInput.focus();
        textInput.setSelectionRange(newPos, newPos);
        katman.text = next;
        renderLayerList();
        render();
      });
      symbolList.appendChild(btn);
    });

    // Paspartu
    paspartuToggle.addEventListener("change", function () {
      state.paspartu = paspartuToggle.checked;
      render();
    });

    // Boyut/varyant
    function loadProduct() {
      if (!productHandle) return;
      fetch("/products/" + productHandle + ".js")
        .then(function (r) {
          if (!r.ok) throw new Error("urun bulunamadi");
          return r.json();
        })
        .then(function (p) {
          product = p;
          sizeSelect.innerHTML = "";
          // Derin varyantlari ("24x33 Derin") ayri olcu degil - listeye girmez.
          p.variants.filter(function (v) { return !/ (Derin|Galeri)$/.test(v.title); }).forEach(function (v, idx) {
            var opt = document.createElement("option");
            opt.value = v.id;
            sizeSelect.appendChild(opt);
            if (idx === 0) {
              state.size = v.title;
              applyPosterSize(v.title);
            }
          });
          boyutEtiketleriniYaz();
          sizeSelect.addEventListener("change", function () {
            var v = p.variants.find(function (vv) { return String(vv.id) === sizeSelect.value; });
            state.size = v ? v.title : "";
            applyPosterSize(state.size);
          });
        })
        .catch(function (err) {
          setStatus("Urun bilgisi yuklenemedi: " + err.message, true);
        });
    }
    loadProduct();

    // Canvas surukleme / buyutme-kucultme (tiklanan katmani bulup onu aktif/secili yapar)
    var drag = null; // { mode: 'move'|'resize', layer, ... }

    function canvasPoint(evt) {
      var rect = canvas.getBoundingClientRect();
      var clientX = evt.touches ? evt.touches[0].clientX : evt.clientX;
      var clientY = evt.touches ? evt.touches[0].clientY : evt.clientY;
      return {
        x: ((clientX - rect.left) / rect.width) * canvas.width,
        y: ((clientY - rect.top) / rect.height) * canvas.height
      };
    }

    function findLayerBoxAt(p) {
      var boxes = root._cpLayerBoxes || [];
      var hitR = px(HANDLE_HIT_R);

      // ONCE secili katmanin tutamaclari (6 Eylul 2026). Ustteki katmanlar
      // tutamacin uzerine denk geldiginde tutamac yakalanamiyordu.
      var aktifKutu = boxes.filter(function (b) { return b.id === activeLayerId; })[0];
      if (aktifKutu) {
        var t = selectionHandles(aktifKutu);
        if (Math.hypot(p.x - t.resize.x, p.y - t.resize.y) < hitR) {
          return { box: aktifKutu, mode: "resize" };
        }
        if (sekilMi(aktifKutu.id)) {
          if (Math.hypot(p.x - t.en.x, p.y - t.en.y) < hitR) {
            return { box: aktifKutu, mode: "en" };
          }
          if (Math.hypot(p.x - t.boy.x, p.y - t.boy.y) < hitR) {
            return { box: aktifKutu, mode: "boy" };
          }
        }
      }

      for (var i = boxes.length - 1; i >= 0; i--) {
        var box = boxes[i];
        var pad = px(BOX_PAD);
        var resizeHandle = selectionHandles(box).resize;
        var handleDist = Math.hypot(p.x - resizeHandle.x, p.y - resizeHandle.y);
        if (handleDist < hitR) return { box: box, mode: "resize" };
        var rotationRad = -((Number(box.rotation) || 0) * Math.PI) / 180;
        var dx = p.x - box.cx;
        var dy = p.y - box.cy;
        var localX = dx * Math.cos(rotationRad) - dy * Math.sin(rotationRad);
        var localY = dx * Math.sin(rotationRad) + dy * Math.cos(rotationRad);
        if (localX > -box.w / 2 - pad && localX < box.w / 2 + pad && localY > -box.h / 2 - pad && localY < box.h / 2 + pad) {
          return { box: box, mode: "move" };
        }
      }
      return null;
    }

    function onPointerDown(evt) {
      var p = canvasPoint(evt);
      var hit = findLayerBoxAt(p);
      if (!hit) return;
      var layer = state.layers.filter(function (l) { return l.id === hit.box.id; })[0];
      if (!layer) return;
      if (activeLayerId !== layer.id) {
        activeLayerId = layer.id;
        syncFormToActiveLayer();
        renderLayerList();
      }
      if (hit.mode === "en" || hit.mode === "boy") {
        var yerel = yerelNokta(hit.box, p);
        drag = {
          mode: hit.mode, layer: layer, box: hit.box,
          baslangic: hit.mode === "en" ? Math.abs(yerel.x) : Math.abs(yerel.y),
          startScale: layer.scale,
          startScaleY: Number(layer.scaleY) > 0 ? Number(layer.scaleY) : 1
        };
      } else if (hit.mode === "resize") {
        drag = { mode: "resize", layer: layer, startDist: Math.hypot(p.x - hit.box.cx, p.y - hit.box.cy), startScale: layer.scale, cx: hit.box.cx, cy: hit.box.cy };
      } else {
        drag = { mode: "move", layer: layer, offsetX: p.x - hit.box.cx, offsetY: p.y - hit.box.cy };
      }
      evt.preventDefault();
    }

    function onPointerMove(evt) {
      if (!drag) return;
      var p = canvasPoint(evt);
      var margin = state.paspartu ? Math.round(canvas.width * 0.12) : 0;
      var innerW = canvas.width - margin * 2,
        innerH = canvas.height - margin * 2;
      if (drag.mode === "move") {
        var nx = (p.x - drag.offsetX - margin) / innerW;
        var ny = (p.y - drag.offsetY - margin) / innerH;
        drag.layer.x = Math.min(0.95, Math.max(0.05, nx));
        drag.layer.y = Math.min(0.95, Math.max(0.05, ny));
      } else if (drag.mode === "resize") {
        var dist = Math.hypot(p.x - drag.cx, p.y - drag.cy);
        var ratio = dist / Math.max(drag.startDist, 1);
        // Yazi da sekil de kullanicinin istedigi kadar buyutulebilir; tasarim tuvalden
        // tasabilir, baskiya giden alan zaten tuvalin kendisi. Sekillerdeki eski 3x siniri
        // kaldirildi: sekiller sabit 1800px kenarli rasterlerden ciziliyor (custom-poster.js
        // SVG_RASTER_LONG_EDGE) ve tuval en fazla 1500px, yani buyutmek ek bellek ayirmiyor.
        drag.layer.scale = Math.max(0.3, drag.startScale * ratio);
      } else if (drag.mode === "en" || drag.mode === "boy") {
        var y2 = yerelNokta(drag.box, p);
        var simdi = drag.mode === "en" ? Math.abs(y2.x) : Math.abs(y2.y);
        var oran2 = simdi / Math.max(drag.baslangic, 1);
        if (drag.mode === "en") {
          // Yukseklik de `scale`e bagli oldugu icin sadece scale degistirilseydi
          // sekil iki yonde birden buyurdu. scaleY ters yonde duzeltiliyor,
          // boylece bu tutamac SADECE genisligi degistiriyor.
          var yeniOlcek = Math.max(0.3, drag.startScale * oran2);
          drag.layer.scaleY = Math.max(0.15, Math.min(8,
            drag.startScaleY * (drag.startScale / yeniOlcek)));
          drag.layer.scale = yeniOlcek;
        } else {
          drag.layer.scaleY = Math.max(0.15, Math.min(8, drag.startScaleY * oran2));
        }
      }
      render();
      evt.preventDefault();
    }

    function onPointerUp() {
      drag = null;
    }

    canvas.addEventListener("mousedown", onPointerDown);
    canvas.addEventListener("touchstart", onPointerDown, { passive: false });
    window.addEventListener("mousemove", onPointerMove);
    window.addEventListener("touchmove", onPointerMove, { passive: false });
    window.addEventListener("mouseup", onPointerUp);
    window.addEventListener("touchend", onPointerUp);

    /* ============================================================
       posterle: editor araclari (7 Eylul 2026)
       Geri al / ileri al, ortala, tasarimi kaydet-ac.
       Ayrintili gerekce: poster-bot/editor_araclari.py
       ============================================================ */
    (function () {
      var liste = root.querySelector("[data-cp-layer-list]");
      if (!liste || !liste.parentNode) return;

      var KAYIT_ANAHTARI = "posterle_tasarimlarim";
      var sonAcilanAd = "";

      /* Dosya alisverisi (indir / dosyadan ac / JSON kopyala) musteri icin
         degil: Claude ile Codex arasinda tasarim tasimak icin eklenmisti.
         Kullanici "anlamadim, gerekli degilse kaldir" dedi - hakli, magaza
         ziyaretcisinin isine yaramiyor. Silmek yerine bayrak arkasina alindi;
         bir sonraki tasarim aktariminda yine gerekecek.
         Acmak: ?gelistirici=1  |  kapatmak: ?gelistirici=0  (secim kaliyor) */
      var gelistirici = (function () {
        var s = String(location.search || "");
        var acik = /[?&]gelistirici=1(?:&|$)/.test(s);
        var kapali = /[?&]gelistirici=0(?:&|$)/.test(s);
        try {
          if (acik) { localStorage.setItem("posterle_gelistirici", "1"); return true; }
          if (kapali) { localStorage.removeItem("posterle_gelistirici"); return false; }
          return localStorage.getItem("posterle_gelistirici") === "1";
        } catch (e) { return acik; }
      })();
      var EN_FAZLA_KAYIT = 20;

      // ---------- arac cubugu (7 Eylul: duz liste -> gruplu denetim)
      function dugme(metin, baslik, islev, ikon, ekSinif) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "cp-arac" + (ekSinif ? " " + ekSinif : "");
        b.title = baslik;
        b.setAttribute("aria-label", baslik);
        b.innerHTML = '<span class="cp-arac-ikon" aria-hidden="true">' + ikon + "</span>" +
                      '<span class="cp-arac-yazi">' + metin + "</span>";
        b.addEventListener("click", islev);
        return b;
      }

      // Iliskili isler tek bir birlesik denetimde toplaniyor; boylece hangi
      // dugmenin neyle ilgili oldugu bakinca anlasiliyor.
      function grup(baslik) {
        var g = document.createElement("div");
        g.className = "cp-arac-grup";
        if (baslik) {
          var e = document.createElement("span");
          e.className = "cp-arac-grup-ad";
          e.textContent = baslik;
          g.appendChild(e);
        }
        return g;
      }

      var cubuk = document.createElement("div");
      cubuk.className = "cp-araclar";

      var geriBtn = dugme("Geri al", "Son değişikliği geri al (Ctrl+Z)", function () { geriAl(); }, "\u21B6");
      var ileriBtn = dugme("İleri al", "Geri aldığını tekrar uygula (Ctrl+Y)", function () { ileriAl(); }, "\u21B7");
      var gecmisGrubu = grup(null);
      gecmisGrubu.appendChild(geriBtn);
      gecmisGrubu.appendChild(ileriBtn);

      var yatayBtn = dugme("Yatay", "Seçili öğeyi yatayda ortala", function () { ortala("x"); }, "\u2194");
      var dikeyBtn = dugme("Dikey", "Seçili öğeyi dikeyde ortala", function () { ortala("y"); }, "\u2195");
      var ortalaGrubu = grup("Ortala");
      ortalaGrubu.appendChild(yatayBtn);
      ortalaGrubu.appendChild(dikeyBtn);

      var kayitBtn = dugme("Tasarımlarım", "Tasarımı kaydet veya kayıtlı tasarımı aç",
                           function () { paneliAcKapa(); }, "\u2691", "cp-arac--tek");

      cubuk.appendChild(gecmisGrubu);
      cubuk.appendChild(ortalaGrubu);
      cubuk.appendChild(kayitBtn);

      // Cubuk tuvalin HEMEN ALTINA giriyor (10 Eylul 2026, kullanici istegi).
      // Bu dugmeler tuvale uygulanan isler; sol sutunda, katman listesinin
      // ustunde durunca kullanici tuvale bakarken dugmeler baska yerde kaliyordu.
      // Onizleme sutunu bulunamazsa eski yerinde kaliyor.
      var onizlemeSutun = root.querySelector(".cp-preview-col");
      var tuvalKutu = root.querySelector(".cp-canvas-box");
      if (onizlemeSutun && tuvalKutu && tuvalKutu.parentNode === onizlemeSutun) {
        cubuk.classList.add("cp-araclar--onizleme");
        onizlemeSutun.insertBefore(cubuk, tuvalKutu);
      } else {
        liste.parentNode.insertBefore(cubuk, liste);
      }

      // ---------- kayit paneli
      var panel = document.createElement("div");
      panel.className = "cp-kayit-panel";
      panel.hidden = true;
      panel.innerHTML =
        '<div class="cp-kayit-satir">' +
        '  <input type="text" class="cp-kayit-ad" maxlength="40" placeholder="Tasarıma bir ad ver">' +
        '  <button type="button" class="cp-btn cp-kayit-ekle">Kaydet</button>' +
        "</div>" +
        '<div class="cp-kayit-liste"></div>' +
        '<div class="cp-kayit-alt">' +
        '  <button type="button" class="cp-btn cp-kayit-indir-su" ' +
        '          title="Şu an tuvaldeki katmanlı tasarımı .json dosyası olarak indir">' +
        '    \u2193 Tasarımı indir (.json)</button>' +
        '  <button type="button" class="cp-btn cp-kayit-ac-dosya" ' +
        '          title="Daha önce indirilmiş bir .json tasarım dosyasını aç">' +
        '    \u2191 Dosyadan tasarım aç</button>' +
        '  <button type="button" class="cp-btn cp-kayit-kopyala" ' +
        '          title="Tasarımın JSON içeriğini panoya kopyala ve aşağıda göster">' +
        '    JSON\'u kopyala</button>' +
        "</div>" +
        '<textarea class="cp-kayit-json" readonly hidden ' +
        '          aria-label="Tasarımın JSON içeriği"></textarea>' +
        '<p class="cp-kayit-not">Kayıtlar bu tarayıcıda saklanır, sunucuya gönderilmez. ' +
        "Tarayıcı verilerini silersen kayıtlar da gider. Başka bir tarayıcıya taşımak için " +
        'tasarımı .json olarak indir, orada "Dosyadan tasarım aç" ile geri yükle.</p>';
      // Panel cubugun hemen ardinda kaliyor: cubuk tasindiysa panel de tasinir.
      // Ayri birakilsaydi "Tasarimlarim"a basinca sayfanin baska yerinde bir sey
      // aciliyordu. Varsayilan olarak gizli, yani tuvalin altinda yer kaplamiyor.
      cubuk.parentNode.insertBefore(panel, cubuk.nextSibling);

      var adInput = panel.querySelector(".cp-kayit-ad");
      var listeKutu = panel.querySelector(".cp-kayit-liste");

      function paneliAcKapa() {
        panel.hidden = !panel.hidden;
        if (!panel.hidden) {
          kayitlariCiz();
          adInput.value = sonAcilanAd || ("Tasarımım " + (kayitlariOku().length + 1));
          adInput.focus();
        }
      }

      function kayitlariOku() {
        try { return JSON.parse(localStorage.getItem(KAYIT_ANAHTARI) || "[]") || []; }
        catch (e) { return []; }
      }

      function kayitlariYaz(d) {
        try { localStorage.setItem(KAYIT_ANAHTARI, JSON.stringify(d)); return true; }
        catch (e) { return false; }
      }

      function kayitlariCiz() {
        var kayitlar = kayitlariOku();
        listeKutu.innerHTML = "";
        if (!kayitlar.length) {
          var bos = document.createElement("p");
          bos.className = "cp-kayit-bos";
          bos.textContent = "Henüz kayıtlı tasarımın yok.";
          listeKutu.appendChild(bos);
          return;
        }
        kayitlar.forEach(function (k, i) {
          var satir = document.createElement("div");
          satir.className = "cp-kayit-oge";
          var ad = document.createElement("span");
          ad.className = "cp-kayit-oge-ad";
          ad.textContent = k.ad;
          var ac = document.createElement("button");
          ac.type = "button"; ac.className = "cp-btn"; ac.textContent = "Aç";
          ac.addEventListener("click", function () {
            sonAcilanAd = k.ad;
            durumuYukle(k.kod, '"' + k.ad + "\" açıldı.");
            panel.hidden = true;
          });
          var sil = document.createElement("button");
          sil.type = "button"; sil.className = "cp-btn cp-btn--sade"; sil.textContent = "Sil";
          sil.addEventListener("click", function () {
            var d = kayitlariOku(); d.splice(i, 1); kayitlariYaz(d); kayitlariCiz();
          });
          satir.appendChild(ad); satir.appendChild(ac);
          if (gelistirici) {
            var indir = document.createElement("button");
            indir.type = "button"; indir.className = "cp-btn cp-btn--ikon";
            indir.title = "Katmanlı tasarımı .json olarak indir";
            indir.setAttribute("aria-label", k.ad + " tasarımını indir");
            indir.textContent = "\u2193";
            indir.addEventListener("click", function () { dosyaIndir(k.ad, k.kod); });
            satir.appendChild(indir);
          }
          satir.appendChild(sil);
          listeKutu.appendChild(satir);
        });
      }

      panel.querySelector(".cp-kayit-ekle").addEventListener("click", function () {
        var kod = durumKodu();
        if (kod === null) { setStatus("Tasarım kaydedilemedi."); return; }
        var ad = (adInput.value || "").trim() || "Tasarımım";
        var kayitlar = kayitlariOku();
        kayitlar.unshift({ ad: ad, kod: kod, tarih: Date.now() });
        if (kayitlar.length > EN_FAZLA_KAYIT) kayitlar.length = EN_FAZLA_KAYIT;
        if (kayitlariYaz(kayitlar)) {
          setStatus('"' + ad + '" kaydedildi.');
          kayitlariCiz();
        } else {
          setStatus("Tarayıcı depolaması dolu ya da kapalı; kaydedilemedi.");
        }
      });

      /* ---------- dosyaya aktar / dosyadan al (9 Eylul 2026)
         Kayitlar localStorage'da durdugu icin yalnizca kaydedildikleri
         tarayicida gorunuyorlar. Baska bir tarayicida yapilan tasarimi buraya
         tasimanin baska yolu yoktu. Dosya, editorun kendi kayit kodunu
         (CP.encodeState) tasiyor; boylece arka plan, olcu, yazilar, fontlar,
         renkler, sekiller, konumlar, olcekler, donus acilari ve katman sirasi
         eksiksiz geliyor ve tasarim duzenlenebilir kaliyor. */
      var DOSYA_SURUM = 1;

      function dosyaAdiYap(ad) {
        // Turkce harfleri elle esliyoruz: toLowerCase() "İ" harfinde ayri bir
        // birlestirme noktasi uretiyor ve dosya adi bozuluyor.
        var kaynak = "ÇĞİÖŞÜçğıöşü";
        var hedef = "CGIOSUcgiosu";
        var s = String(ad || "tasarim");
        var cikti = "";
        for (var i = 0; i < s.length; i++) {
          var h = s.charAt(i);
          var y = kaynak.indexOf(h);
          if (y >= 0) h = hedef.charAt(y);
          cikti += /[A-Za-z0-9]/.test(h) ? h : "-";
        }
        cikti = cikti.replace(/-+/g, "-").replace(/^-|-$/g, "");
        return "posterle-" + (cikti || "tasarim");
      }

      function paketMetni(ad, kod) {
        return JSON.stringify({
          posterle: "tasarim",
          surum: DOSYA_SURUM,
          ad: ad || "Tasarım",
          tarih: new Date().toISOString(),
          kod: kod
        }, null, 2);
      }

      function dosyaIndir(ad, kod) {
        if (!kod) { setStatus("Bu tasarım indirilemedi."); return; }
        var url = URL.createObjectURL(
          new Blob([paketMetni(ad, kod)], { type: "application/json" }));
        var a = document.createElement("a");
        a.href = url;
        a.download = dosyaAdiYap(ad) + ".json";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function () { URL.revokeObjectURL(url); }, 5000);
        setStatus('"' + (ad || "Tasarım") + '" indirildi.');
      }

      function paketiCoz(metin) {
        var kod = null, ad = "";
        try {
          var p = JSON.parse(metin);
          if (p && typeof p.kod === "string") { kod = p.kod; ad = p.ad || ""; }
          else if (typeof p === "string") { kod = p; }
        } catch (e) {
          kod = String(metin || "").trim();   // duz kod metni de kabul edilsin
        }
        if (!kod) return null;
        // Once cozulebiliyor mu diye bakiyoruz; bozuk dosya tuvale dokunmasin.
        try {
          var d = CP.decodeState(kod);
          if (!d || !d.layers || typeof d.layers.length !== "number") return null;
        } catch (e2) { return null; }
        return { kod: kod, ad: ad };
      }

      function dosyadanAl(dosya) {
        if (!dosya) return;
        var okuyucu = new FileReader();
        okuyucu.onerror = function () { setStatus("Dosya okunamadı."); };
        okuyucu.onload = function () {
          var c = paketiCoz(okuyucu.result);
          if (!c) { setStatus("Bu dosya bir posterle tasarımı değil."); return; }
          var ad = c.ad || String(dosya.name || "").replace(/\.json$/i, "") || "Dosyadan gelen tasarım";
          var kayitlar = kayitlariOku();
          kayitlar.unshift({ ad: ad, kod: c.kod, tarih: Date.now() });
          if (kayitlar.length > EN_FAZLA_KAYIT) kayitlar.length = EN_FAZLA_KAYIT;
          kayitlariYaz(kayitlar);
          sonAcilanAd = ad;
          kayitlariCiz();
          durumuYukle(c.kod, '"' + ad + '" dosyadan açıldı ve Tasarımlarım listesine eklendi.');
        };
        okuyucu.readAsText(dosya);
      }

      var dosyaSecici = document.createElement("input");
      dosyaSecici.type = "file";
      dosyaSecici.accept = "application/json,.json";
      dosyaSecici.style.display = "none";
      dosyaSecici.addEventListener("change", function () {
        var d = this.files && this.files[0];
        this.value = "";            // ayni dosya arka arkaya secilebilsin
        dosyadanAl(d);
      });
      panel.appendChild(dosyaSecici);

      panel.querySelector(".cp-kayit-indir-su").addEventListener("click", function () {
        dosyaIndir((adInput.value || "").trim() || "Tasarımım", durumKodu());
      });
      panel.querySelector(".cp-kayit-ac-dosya").addEventListener("click", function () {
        dosyaSecici.click();
      });

      var jsonKutu = panel.querySelector(".cp-kayit-json");

      function belgeKopyala() {
        try { return document.execCommand("copy"); } catch (e) { return false; }
      }

      if (!gelistirici) {
        panel.querySelector(".cp-kayit-alt").hidden = true;
        jsonKutu.hidden = true;
        // Not metni sade haline donuyor; dosya cumlesi artik yaniltici olurdu.
        panel.querySelector(".cp-kayit-not").textContent =
          "Kayıtlar bu tarayıcıda saklanır, sunucuya gönderilmez. " +
          "Tarayıcı verilerini silersen kayıtlar da gider.";
      }

      panel.querySelector(".cp-kayit-kopyala").addEventListener("click", function () {
        var kod = durumKodu();
        if (!kod) { setStatus("Tasarım kopyalanamadı."); return; }
        var metin = paketMetni((adInput.value || "").trim() || "Tasarımım", kod);
        // Once ekrana koyuyoruz: pano calismasa bile icerik erisilebilir kalsin.
        jsonKutu.value = metin;
        jsonKutu.hidden = false;
        jsonKutu.focus();
        jsonKutu.select();
        function bitti(oldu) {
          setStatus(oldu
            ? "JSON panoya kopyalandı; aşağıdaki kutuda da duruyor."
            : "Panoya kopyalanamadı; aşağıdaki kutudan elle kopyalayabilirsin.");
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(metin).then(
            function () { bitti(true); },
            function () { bitti(belgeKopyala()); });
        } else {
          bitti(belgeKopyala());
        }
      });

      // ---------- gecmis
      var gecmis = [];
      var indeks = -1;
      var kilit = false;
      var zaman = null;

      function durumKodu() {
        try { return CP.encodeState(state); } catch (e) { return null; }
      }

      function dugmeleriGuncelle() {
        geriBtn.disabled = indeks <= 0;
        ileriBtn.disabled = indeks < 0 || indeks >= gecmis.length - 1;
      }

      function kaydet() {
        var kod = durumKodu();
        if (kod === null) return;
        if (indeks >= 0 && gecmis[indeks] === kod) return;   // degismemis
        gecmis = gecmis.slice(0, indeks + 1);
        gecmis.push(kod);
        if (gecmis.length > 60) gecmis.shift();
        indeks = gecmis.length - 1;
        dugmeleriGuncelle();
      }

      function planla() {
        if (kilit) return;
        clearTimeout(zaman);
        // Surukleme boyunca render onlarca kez cagriliyor; yalniz DURDUKTAN
        // sonraki hal gecmise giriyor.
        zaman = setTimeout(kaydet, 450);
      }

      function durumuYukle(kod, mesaj) {
        var yeni;
        try { yeni = CP.decodeState(kod); } catch (e) { return; }
        kilit = true;
        clearTimeout(zaman);
        // Poster olcusu bir satin alma secenegi; geri alma onu degistirmesin.
        if (sizeSelect && sizeSelect.value) yeni.size = sizeSelect.value;
        state = yeni;
        var ilk = state.layers[0];
        activeLayerId = ilk ? ilk.id : null;
        activeColorRole = ilk && ilk.type === "shape"
          ? ((ilk.parts && ilk.parts[0]) || "outer") : "color";
        activeBgColorRole = (state.bgParts && state.bgParts[0]) || "";
        bgImage = null;
        if (paspartuToggle) paspartuToggle.checked = !!state.paspartu;
        root.querySelectorAll("[data-cp-bg-item]").forEach(function (item) {
          item.classList.toggle("is-selected", item.getAttribute("data-url") === state.bg);
        });
        renderBgColorRoles();
        ensureBackgroundImageLoaded();
        ensureShapeImagesLoaded();
        syncFormToActiveLayer();
        renderLayerList();
        render();
        if (mesaj) setStatus(mesaj);
        // Arka plan/sekil gorselleri asenkron yuklenip tekrar render tetikliyor;
        // o turlar gecmise yeni kayit olarak girmesin diye kilit biraz surer.
        setTimeout(function () { kilit = false; dugmeleriGuncelle(); }, 700);
      }

      function geriAl() {
        clearTimeout(zaman);
        kaydet();                       // bekleyen degisiklik varsa once o yazilsin
        if (indeks <= 0) return;
        indeks -= 1;
        durumuYukle(gecmis[indeks], "Geri alındı.");
      }

      function ileriAl() {
        if (indeks < 0 || indeks >= gecmis.length - 1) return;
        indeks += 1;
        durumuYukle(gecmis[indeks], "İleri alındı.");
      }

      function ortala(eksen) {
        var l = activeLayer();
        if (!l) { setStatus("Önce bir yazı ya da şekil seç."); return; }
        if (eksen === "x") l.x = 0.5; else l.y = 0.5;
        render();
        setStatus(eksen === "x" ? "Yatayda ortalandı." : "Dikeyde ortalandı.");
      }

      // render'i sarmala: tek yakalama noktasi
      var _render = render;
      render = function () { _render(); planla(); };

      document.addEventListener("keydown", function (e) {
        if (!(e.ctrlKey || e.metaKey)) return;
        var a = document.activeElement;
        // Yazi alanindayken tarayicinin kendi geri almasi calissin
        if (a && (a.tagName === "INPUT" || a.tagName === "TEXTAREA")) return;
        var k = (e.key || "").toLowerCase();
        if (k === "z" && !e.shiftKey) { e.preventDefault(); geriAl(); }
        else if (k === "y" || (k === "z" && e.shiftKey)) { e.preventDefault(); ileriAl(); }
      });

      // ---------- cp-adresten-tasarim-yukle (10 Eylul 2026)
      // Sepetteki "Tasarimi duzenle" baglantisi tasarimi adres cubugunda tasiyor.
      // Tasarimci adres cubugundaki durumu normalde YALNIZCA mode=view yolunda
      // uyguluyordu; o yol da salt goruntuleme (bu dosyanin en ustundeki erken
      // cikis), yani musteri tasarimini goruyor ama duzenleyemiyordu.
      // Burada ayni durum, "Tasarimlarim -> Ac" ile AYNI dogrulanmis yoldan
      // (durumuYukle) editore yukleniyor - yeni bir yukleme mantigi yazilmadi.
      (function () {
        var p = new URLSearchParams(location.search);
        if (!p.get("layers")) return;             // adres tasarim tasimiyor
        if (p.get("mode") === "view") return;     // salt goruntuleme yolu ayri
        try {
          durumuYukle(location.search,
                      "Tasarımın açıldı; düzenleyip tekrar sepete ekleyebilirsin.");
        } catch (e) {
          // Bozuk/eskimis baglanti: bos tuvalle devam, musteriye hata gosterme
        }
      })();

      kaydet();            // acilis hali
      dugmeleriGuncelle();
    })();

    // Sepete ekle
    addBtn.addEventListener("click", function () {
      if (!product) {
        setStatus("Urun bilgisi henuz yuklenmedi, birazdan tekrar dene.", true);
        return;
      }
      var hasContent = state.layers.some(function (l) { return l.type === "shape" ? !!l.shapeUrl : l.text && l.text.trim(); });
      if (!hasContent) {
        setStatus("Lutfen once bir yazi veya sekil ekle.", true);
        return;
      }
      if (activePhotoTemplate && !templatePhotoImage) {
        setStatus("Bu şablon için önce çocuğunun fotoğrafını yükle.", true);
        yukleKutu.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      var variant = product.variants.find(function (v) { return String(v.id) === sizeSelect.value; });
      if (!variant) {
        setStatus("Lutfen bir boyut sec.", true);
        return;
      }
      var secModel = seciliCerceveModeli();
      if (secModel !== "Basic") {
        var modelVaryant = modelEsi(variant, secModel);
        if (!modelVaryant) {
          setStatus("Bu ölçüde " + secModel + " çerçeve yok.", true);
          return;
        }
        variant = modelVaryant;
      }

      addBtn.disabled = true;
      setStatus("Sepete ekleniyor...");

      // Musteri kendi fotografini arka plan yaptiysa onun data URL'i baglantiya SIGMAZ
      // (megabaytlar). Baglanti gorselsiz uretilir; asil dosya siparise ayrica eklenir.
      var baglantiDurumu = yuklenenDosya
        ? Object.assign({}, state, activePhotoTemplate
          ? {}
          : { bg: "", bgParts: [], bgColors: {} })
        : state;
      var query = CP.encodeState(baglantiDurumu);
      var designUrl = viewPageUrl + "?mode=view&" + query;
      var allText = state.layers
        .map(function (l) { return l.type === "shape" ? "[" + (l.shapeLabel || "sekil") + "]" : l.text; })
        .filter(Boolean)
        .join(" / ");

      var ozellikler = {
        "Arka Plan": state.bgLabel || "-",
        "Yazı": allText,
        "Beyaz kenar boşluğu": state.paspartu ? "Evet" : "Hayır",
        "Çerçeve": seciliCerceveDegeri(),
        "Çerçeve Modeli": seciliCerceveModeli(),
        "_Tasarım Linki": designUrl
      };

      // Tasarimin GORUNTUSU de siparise eklenir (6 Eylul 2026).
      // Onceden sepete yalniz metin ozellikleri ve "_Tasarim Linki" gidiyordu; sepette
      // urunun kendi krem kapak fotografi goruluyor, musteri tasarimini goremiyordu ve
      // siparis geldiginde baski icin linki acip yeniden uretmek gerekiyordu. Artik
      // tuvalin PNG'si her durumda satira dosya olarak ekleniyor. NOT: bu goruntu
      // onizleme cozunurlugundedir (tuval olcusu); yuksek cozunurluklu baski dosyasi
      // icin "_Tasarim Linki" hala tek gercek kaynak.
      function tuvalBlobu() {
        return new Promise(function (resolve) {
          if (!canvas || !canvas.toBlob) return resolve(null);
          try {
            canvas.toBlob(function (blob) { resolve(blob || null); }, "image/png");
          } catch (e) {
            resolve(null);
          }
        });
      }

      var istek;
      if (yuklenenDosya) {
        // Shopify'da satir ozelligi olarak DOSYA yuklemek icin JSON degil FormData gerekir;
        // dosya siparise eklenir ve baski dosyasi ondan uretilir.
        ozellikler["Arka Plan"] = activePhotoTemplate
          ? state.bgLabel + " | Müşteri fotoğrafı: " + yuklenenDosya.name
          : "Müşteri görseli: " + yuklenenDosya.name;
        ozellikler["_Not"] = activePhotoTemplate
          ? "Müşteri fotoğrafı tasarım linkinde görünmez; siparişe ekli dosyayı kemerli alana ortalı kırp."
          : "Arka plandaki müşteri görseli tasarım linkinde görünmez, siparişe ekli dosyayı kullan.";
        istek = tuvalBlobu().then(function (tasarimBlob) {
          var fd = new FormData();
          fd.append("id", variant.id);
          fd.append("quantity", 1);
          Object.keys(ozellikler).forEach(function (k) {
            fd.append("properties[" + k + "]", ozellikler[k]);
          });
          fd.append("properties[Yüklenen Görsel]", yuklenenDosya, yuklenenDosya.name);
          if (tasarimBlob) fd.append("properties[Tasarım Görseli]", tasarimBlob, "tasarim.png");
          return fetch("/cart/add.js", { method: "POST", body: fd });
        });
      } else {
        // Dosya ozelligi JSON ile gonderilemedigi icin burada da FormData kullaniliyor.
        istek = tuvalBlobu().then(function (tasarimBlob) {
          if (!tasarimBlob) {
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                items: [{ id: variant.id, quantity: 1, properties: ozellikler }]
              })
            });
          }
          var fd = new FormData();
          fd.append("id", variant.id);
          fd.append("quantity", 1);
          Object.keys(ozellikler).forEach(function (k) {
            fd.append("properties[" + k + "]", ozellikler[k]);
          });
          fd.append("properties[Tasarım Görseli]", tasarimBlob, "tasarim.png");
          return fetch("/cart/add.js", { method: "POST", body: fd });
        });
      }

      istek
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || "sepete eklenemedi"); });
          return r.json();
        })
        .then(function () {
          setStatus("Sepete eklendi! Sepete yonlendiriliyorsun...");
          window.location.href = "/cart";
        })
        .catch(function (err) {
          setStatus("Hata: " + err.message, true);
          addBtn.disabled = false;
        });
    });

    renderPresetCards();
    syncFormToActiveLayer();
    renderLayerList();
    render();
    // Ilk cizim fontlardan once olmus olabilir; gelince bir kez tazele.
    fontlarHazir.then(function () { render(); });
  });
})();

/* ============================================================
   Baslangic ekrani KALDIRILDI — 11 Eylul 2026
   Once musteri tasarimciya girmeden "Sifirdan Tasarla" /
   "Sablondan Basla" secimine dusuyordu (?mod=). Kullanici:
   "sablondan basla kismini kaldiralim komple, oradan
   vazgectim, kafa karisikligi olmasin". Artik sayfa dogrudan
   tasarimciyi aciyor; ?mod= parametresi yok sayiliyor.
   "ILHAM AL" seridi yerinde duruyor.
   ============================================================ */

/* ============================================================
   Sadelestirilmis SABLON ekrani (6 Eylul 2026)
   Kullanicinin istegi: "sablonla yapma kismi bambaska bir kisim
   olacak, fotograflarini yukleyebilecekler ve sablondaki bosluga
   o fotograf gelecek."

   Onceden: fotografli bir sablon secilince musteri TAM tasarimciya
   dusuyordu (40+ desenli arka plan galerisi, sekiller, katmanlar) ve
   fotografi yukleyecegi kutuyu desen galerisinin icinde aramak
   zorundaydi. Simdi sablon secilince root'a "cp-sablon" sinifi
   eklenir; yukleme kutusu GERCEKTEN tasinarak (klonlanmaz, boylece
   mevcut olay dinleyicileri ve dosya referansi korunur) en uste,
   kendi kartina alinir; arka plan galerisi ve sekil ekleme gizlenir.
   Musteriye kalan: fotografini yukle -> yazilari degistir -> boyut ->
   sepete ekle.

   Tamamen EKLEMEDIR: yukaridaki tasarimci kodunun hicbir fonksiyonu
   degistirilmedi, sadece DOM yerlesimi ve gorunurluk yonetiliyor.
   ============================================================ */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    var params = new URLSearchParams(window.location.search);
    if (params.get("mode") === "view") return;

    var root = document.querySelector("[data-cp-designer]");
    if (!root) return;

    var panel = root.querySelector(".cp-panel");
    var bgList = root.querySelector("[data-cp-bg-list]");
    var presetList = root.querySelector("[data-cp-preset-list]");
    if (!panel || !bgList) return;

    var yukleKutu = bgList.querySelector(".cp-bg-upload");
    if (!yukleKutu) return;

    // Arka plan kartini isaretle ki sablon modunda CSS ile gizleyebilelim
    var bgKart = bgList.closest(".cp-card");
    if (bgKart) bgKart.classList.add("cp-card--arkaplan");

    // --- Fotograf karti (basta gizli, sadece sablon modunda gorunur)
    var kart = document.createElement("section");
    kart.className = "cp-card cp-card--fotograf";
    kart.hidden = true;

    var baslik = document.createElement("h2");
    baslik.className = "cp-step";
    baslik.textContent = "Fotoğrafını yükle";
    kart.appendChild(baslik);

    var aciklama = document.createElement("p");
    aciklama.className = "cp-step-desc";
    aciklama.textContent =
      "Kutuya dokun ve fotoğrafını seç. Şablondaki boşluğa otomatik yerleşir; " +
      "istersen sonradan başka bir fotoğrafla değiştirebilirsin.";
    kart.appendChild(aciklama);

    var yuva = document.createElement("div");
    yuva.className = "cp-fotograf-yuva";
    kart.appendChild(yuva);

    panel.insertBefore(kart, panel.firstChild);

    // --- Mod gecisleri
    function sablonModunaGec() {
      if (root.classList.contains("cp-sablon")) return;
      root.classList.add("cp-sablon");
      kart.hidden = false;
      yuva.appendChild(yukleKutu);          // TASINIR, klonlanmaz
    }

    function sablonModundanCik() {
      if (!root.classList.contains("cp-sablon")) return;
      root.classList.remove("cp-sablon");
      kart.hidden = true;
      bgList.insertBefore(yukleKutu, bgList.firstChild);
    }

    // Fotografli sablon kartlarina data-cp-photo="1" veriliyor (bkz. renderPresetCards).
    if (presetList) {
      presetList.addEventListener("click", function (ev) {
        var kartEl = ev.target && ev.target.closest ? ev.target.closest(".cp-preset-card") : null;
        if (!kartEl) return;
        if (kartEl.hasAttribute("data-cp-photo")) sablonModunaGec();
        else sablonModundanCik();
      });
    }

    // "Sifirdan Tasarla" / bos tuval secenekleri sablon modundan cikarir
    root.addEventListener("click", function (ev) {
      var btn = ev.target && ev.target.closest ? ev.target.closest("[data-cp-go]") : null;
      if (btn && btn.getAttribute("data-cp-go") === "sifirdan") sablonModundanCik();
    });
  });
})();
